import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** All currencies are stored as Numbers */
  Currency: any;
  /** Date custom scalar type */
  Date: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Action = {
  __typename?: "Action";
  name?: Maybe<Scalars["String"]>;
};

export type Activity = {
  __typename?: "Activity";
  id: Scalars["ID"];
  actor?: Maybe<Scalars["String"]>;
  objectId?: Maybe<Scalars["String"]>;
  objectType?: Maybe<Scalars["String"]>;
  verb?: Maybe<Scalars["JSON"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  properties?: Maybe<Scalars["JSON"]>;
};

export type AirtableServiceInfoInput = {
  serviceId?: Maybe<Scalars["String"]>;
  servicePrice?: Maybe<Scalars["String"]>;
};

export type AppVersion = {
  __typename?: "AppVersion";
  version?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
};

export type Appointment = {
  __typename?: "Appointment";
  id: Scalars["ID"];
  allDay?: Maybe<Scalars["Boolean"]>;
  technician?: Maybe<Technician>;
  subject?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
  timeWindow?: Maybe<TimeWindow>;
  job?: Maybe<Job>;
  isFixed?: Maybe<Scalars["Boolean"]>;
  timeZone?: Maybe<Scalars["String"]>;
  activityFeed?: Maybe<Array<Maybe<Activity>>>;
  overrideOutsideServiceZone?: Maybe<Scalars["Boolean"]>;
  partsOrderedNotificationSent?: Maybe<Scalars["Boolean"]>;
  partsDueDate?: Maybe<Scalars["Date"]>;
  duration?: Maybe<Scalars["Float"]>;
  location?: Maybe<Scalars["String"]>;
  inTransit?: Maybe<Scalars["Boolean"]>;
  isSameDay?: Maybe<Scalars["Boolean"]>;
};

export enum AppointmentAddressType {
  Home = "HOME",
  HomePartsStore = "HOME_PARTS_STORE",
  ServiceAreaAnchor = "SERVICE_AREA_ANCHOR",
  ServiceLocation = "SERVICE_LOCATION",
}

export type AppointmentInput = {
  technician: Scalars["ID"];
  job?: Maybe<Scalars["ID"]>;
  subject?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  startDate?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
  allDay?: Maybe<Scalars["Boolean"]>;
  isFixed?: Maybe<Scalars["Boolean"]>;
  duration?: Maybe<Scalars["Float"]>;
  location?: Maybe<Scalars["String"]>;
  inTransit?: Maybe<Scalars["Boolean"]>;
  timeWindow?: Maybe<TimeWindowInput>;
  technicianCopy?: Maybe<Scalars["JSON"]>;
  timeZone?: Maybe<Scalars["String"]>;
  overrideOutsideServiceZone?: Maybe<Scalars["Boolean"]>;
  availabilitySnapshotId?: Maybe<Scalars["String"]>;
  appointmentSnapshotId?: Maybe<Scalars["String"]>;
  partsDueDate?: Maybe<Scalars["Date"]>;
};

export type AppointmentSuggestion = {
  __typename?: "AppointmentSuggestion";
  timeCategory?: Maybe<AppointmentTimeCategory>;
  appointmentSnapshotId?: Maybe<Scalars["String"]>;
  availabilitySnapshotId?: Maybe<Scalars["String"]>;
  score?: Maybe<Scalars["Float"]>;
  scores?: Maybe<Scores>;
  technician?: Maybe<Technician>;
  subject?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
  timeWindow?: Maybe<TimeWindow>;
  market?: Maybe<Market>;
  serviceLocation?: Maybe<Scalars["String"]>;
  arrivalServiceLocation?: Maybe<Scalars["String"]>;
  arrivalAddressType?: Maybe<AppointmentAddressType>;
  departureServiceLocation?: Maybe<Scalars["String"]>;
  departureAddressType?: Maybe<AppointmentAddressType>;
  straightLineDistanceInMilesArrival?: Maybe<Scalars["Float"]>;
  straightLineDistanceInMilesDeparture?: Maybe<Scalars["Float"]>;
  driveTimes?: Maybe<DriveTimes>;
  technicianExistingAppointments?: Maybe<Array<Maybe<ExistingAppointment>>>;
  technicianCapacity?: Maybe<TechnicianDayCapacity>;
  marketCapacity?: Maybe<MarketDayCapacity>;
};

export type AppointmentSuggestionError = {
  __typename?: "AppointmentSuggestionError";
  code: Scalars["String"];
  message: Scalars["String"];
};

export type AppointmentSuggestionsResult = {
  __typename?: "AppointmentSuggestionsResult";
  suggestions: Array<Maybe<AppointmentSuggestion>>;
  error?: Maybe<AppointmentSuggestionError>;
  marketCapacityByDay?: Maybe<Array<MarketDayCapacity>>;
};

export enum AppointmentTimeCategory {
  FirstOfDayEarly = "FIRST_OF_DAY_EARLY",
  FirstOfDay = "FIRST_OF_DAY",
  LastOfDay = "LAST_OF_DAY",
  Regular = "REGULAR",
}

export type ApprovalInfo = {
  __typename?: "ApprovalInfo";
  approvedBy?: Maybe<Scalars["String"]>;
  approvalStatus?: Maybe<Scalars["String"]>;
  submittedBy?: Maybe<Scalars["String"]>;
  approvalMethod?: Maybe<Scalars["String"]>;
  spokeTo?: Maybe<Scalars["String"]>;
};

export type ApprovalInfoInput = {
  approvedBy?: Maybe<Scalars["String"]>;
  approvalStatus?: Maybe<Scalars["String"]>;
  submittedBy?: Maybe<Scalars["String"]>;
  approvalMethod?: Maybe<Scalars["String"]>;
  spokeTo?: Maybe<Scalars["String"]>;
};

export type AvailabilitySnapshotRes = {
  __typename?: "AvailabilitySnapshotRes";
  availabilitySnapshotId?: Maybe<Scalars["String"]>;
  error?: Maybe<Scalars["String"]>;
};

export type AvailabilityWindow = {
  __typename?: "AvailabilityWindow";
  arrivalRange?: Maybe<StartTimeRange>;
  startRange?: Maybe<StartTimeRange>;
};

export type BrakePadsListItem = {
  __typename?: "BrakePadsListItem";
  padThickness?: Maybe<PadThickness>;
  condition?: Maybe<Scalars["String"]>;
};

export type BrakePadsListItemInput = {
  padThickness?: Maybe<PadThicknessInput>;
  condition?: Maybe<Scalars["String"]>;
};

export type CalculatePossibleEjiPriceInfoInput = {
  pricingConfig?: Maybe<EjiPricingConfigInput>;
  services: Array<Maybe<PossibleEjiServiceInput>>;
  discounts?: Maybe<Array<Maybe<EjiDiscountInput>>>;
  marketName: Scalars["String"];
  taxable: Scalars["Boolean"];
  laborTaxRate?: Maybe<Scalars["Float"]>;
  partsTaxRate?: Maybe<Scalars["Float"]>;
  calculateAllServices?: Maybe<Scalars["Boolean"]>;
  promoCodes?: Maybe<Array<Maybe<PromoCodeInput>>>;
  jobId?: Maybe<Scalars["String"]>;
};

export type CancelAppointmentInput = {
  appointmentId: Scalars["ID"];
  reason: Scalars["String"];
  notes?: Maybe<Scalars["String"]>;
};

export type CancelationDetails = {
  __typename?: "CancelationDetails";
  method?: Maybe<Scalars["String"]>;
  responsible?: Maybe<Scalars["String"]>;
  representativeSpokenTo?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  timeStamp?: Maybe<Scalars["Date"]>;
  actor?: Maybe<Scalars["String"]>;
};

export type CancelationDetailsInput = {
  method?: Maybe<Scalars["String"]>;
  responsible?: Maybe<Scalars["String"]>;
  representativeSpokenTo?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  timeStamp?: Maybe<Scalars["Date"]>;
  actor?: Maybe<Scalars["String"]>;
};

export type CatalogueDaysOfWeek = {
  __typename?: "CatalogueDaysOfWeek";
  monday?: Maybe<Scalars["Currency"]>;
  tuesday?: Maybe<Scalars["Currency"]>;
  wednesday?: Maybe<Scalars["Currency"]>;
  thursday?: Maybe<Scalars["Currency"]>;
  friday?: Maybe<Scalars["Currency"]>;
  saturday?: Maybe<Scalars["Currency"]>;
  sunday?: Maybe<Scalars["Currency"]>;
};

export type CatalogueDrums = {
  __typename?: "CatalogueDrums";
  standardOption?: Maybe<CatalogueItemOption>;
  premiumOption?: Maybe<CatalogueItemOption>;
  performanceOption?: Maybe<CatalogueItemOption>;
  laborHours?: Maybe<Scalars["Float"]>;
  notes?: Maybe<Scalars["String"]>;
};

export type CatalogueItemOption = {
  __typename?: "CatalogueItemOption";
  brand?: Maybe<Scalars["String"]>;
  basePrice?: Maybe<Scalars["Currency"]>;
  marketAdjustedPrice?: Maybe<Scalars["Currency"]>;
  partsCost?: Maybe<Scalars["Currency"]>;
  commission?: Maybe<Scalars["Currency"]>;
};

export type CatalogueLeadTime = {
  __typename?: "CatalogueLeadTime";
  sameDay?: Maybe<Scalars["Currency"]>;
  nextDay?: Maybe<Scalars["Currency"]>;
  oneToTwoDays?: Maybe<Scalars["Currency"]>;
  twoPlusDays?: Maybe<Scalars["Currency"]>;
};

export type CataloguePads = {
  __typename?: "CataloguePads";
  standardOption?: Maybe<CatalogueItemOption>;
  premiumOption?: Maybe<CatalogueItemOption>;
  performanceOption?: Maybe<CatalogueItemOption>;
  OEMMaterial?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  laborHours?: Maybe<Scalars["Float"]>;
};

export type CatalogueRotors = {
  __typename?: "CatalogueRotors";
  standardOption?: Maybe<CatalogueItemOption>;
  premiumOption?: Maybe<CatalogueItemOption>;
  alternativePricing?: Maybe<Scalars["Currency"]>;
  notes?: Maybe<Scalars["String"]>;
  laborHours?: Maybe<Scalars["Float"]>;
};

export type CatalogueShoes = {
  __typename?: "CatalogueShoes";
  standardOption?: Maybe<CatalogueItemOption>;
  premiumOption?: Maybe<CatalogueItemOption>;
  performanceOption?: Maybe<CatalogueItemOption>;
  laborHours?: Maybe<Scalars["Float"]>;
  notes?: Maybe<Scalars["String"]>;
};

export type CheckListV2BrakeFluidInfo = {
  __typename?: "CheckListV2BrakeFluidInfo";
  ppm?: Maybe<Scalars["String"]>;
  colorGrade?: Maybe<Scalars["String"]>;
  level?: Maybe<Scalars["String"]>;
};

export type CheckListV2BrakeFluidInfoInput = {
  ppm?: Maybe<Scalars["String"]>;
  colorGrade?: Maybe<Scalars["String"]>;
  level?: Maybe<Scalars["String"]>;
};

export type CheckListV2DrumsInfo = {
  __typename?: "CheckListV2DrumsInfo";
  colorGrade?: Maybe<Scalars["String"]>;
  condition?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CheckListV2DrumsInfoInput = {
  colorGrade?: Maybe<Scalars["String"]>;
  condition?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CheckListV2InspectedServices = {
  __typename?: "CheckListV2InspectedServices";
  frontLeftCaliper?: Maybe<CheckListV2InspectedServicesItem>;
  frontRightCaliper?: Maybe<CheckListV2InspectedServicesItem>;
  rearLeftCaliper?: Maybe<CheckListV2InspectedServicesItem>;
  rearRightCaliper?: Maybe<CheckListV2InspectedServicesItem>;
  frontLeftHubAssemblyBearing?: Maybe<CheckListV2InspectedServicesItem>;
  frontRightHubAssemblyBearing?: Maybe<CheckListV2InspectedServicesItem>;
  rearLeftHubAssemblyBearing?: Maybe<CheckListV2InspectedServicesItem>;
  rearRightHubAssemblyBearing?: Maybe<CheckListV2InspectedServicesItem>;
};

export type CheckListV2InspectedServicesInput = {
  frontLeftCaliper?: Maybe<CheckListV2InspectedServicesItemInput>;
  frontRightCaliper?: Maybe<CheckListV2InspectedServicesItemInput>;
  rearLeftCaliper?: Maybe<CheckListV2InspectedServicesItemInput>;
  rearRightCaliper?: Maybe<CheckListV2InspectedServicesItemInput>;
  frontLeftHubAssemblyBearing?: Maybe<CheckListV2InspectedServicesItemInput>;
  frontRightHubAssemblyBearing?: Maybe<CheckListV2InspectedServicesItemInput>;
  rearLeftHubAssemblyBearing?: Maybe<CheckListV2InspectedServicesItemInput>;
  rearRightHubAssemblyBearing?: Maybe<CheckListV2InspectedServicesItemInput>;
};

export type CheckListV2InspectedServicesItem = {
  __typename?: "CheckListV2InspectedServicesItem";
  included?: Maybe<Scalars["Boolean"]>;
  colorGrade?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
};

export type CheckListV2InspectedServicesItemInput = {
  included?: Maybe<Scalars["Boolean"]>;
  colorGrade?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
};

export type CheckListV2PadsInfo = {
  __typename?: "CheckListV2PadsInfo";
  innerPadThickness?: Maybe<Scalars["String"]>;
  outerPadThickness?: Maybe<Scalars["String"]>;
  driverSide?: Maybe<Scalars["String"]>;
  passengerSide?: Maybe<Scalars["String"]>;
  padsThickness?: Maybe<Scalars["String"]>;
  condition?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CheckListV2PadsInfoInput = {
  innerPadThickness?: Maybe<Scalars["String"]>;
  outerPadThickness?: Maybe<Scalars["String"]>;
  driverSide?: Maybe<Scalars["String"]>;
  passengerSide?: Maybe<Scalars["String"]>;
  padsThickness?: Maybe<Scalars["String"]>;
  condition?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CheckListV2RotorsInfo = {
  __typename?: "CheckListV2RotorsInfo";
  thicknessInches?: Maybe<Scalars["String"]>;
  condition?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CheckListV2RotorsInfoInput = {
  thicknessInches?: Maybe<Scalars["String"]>;
  condition?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CheckListV2ShoesInfo = {
  __typename?: "CheckListV2ShoesInfo";
  colorGrade?: Maybe<Scalars["String"]>;
  condition?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CheckListV2ShoesInfoInput = {
  colorGrade?: Maybe<Scalars["String"]>;
  condition?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CheckListV2TireTreadDepth = {
  __typename?: "CheckListV2TireTreadDepth";
  rearDepth?: Maybe<Scalars["String"]>;
  frontDepth?: Maybe<Scalars["String"]>;
  withoutTreadDepth?: Maybe<Scalars["Boolean"]>;
};

export type CheckListV2TireTreadDepthInput = {
  rearDepth?: Maybe<Scalars["String"]>;
  frontDepth?: Maybe<Scalars["String"]>;
  withoutTreadDepth?: Maybe<Scalars["Boolean"]>;
};

export type CloseZeroDollarInvoiceInput = {
  invoiceId: Scalars["ID"];
};

export type ConditionInput = {
  field: Scalars["String"];
  operator: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
  values?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export enum ConditionOperator {
  Equals = "EQUALS",
  NotEquals = "NOT_EQUALS",
  GreaterThanOrEqual = "GREATER_THAN_OR_EQUAL",
  LessThanOrEqual = "LESS_THAN_OR_EQUAL",
  GreaterThan = "GREATER_THAN",
  LessThan = "LESS_THAN",
  Includes = "INCLUDES",
  NotIncludes = "NOT_INCLUDES",
  IncludesAll = "INCLUDES_ALL",
  IncludesAny = "INCLUDES_ANY",
  NotIncludesAll = "NOT_INCLUDES_ALL",
}

export type ConditionType = {
  __typename?: "ConditionType";
  field: Scalars["String"];
  operator: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
  values?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type Contact = {
  __typename?: "Contact";
  id: Scalars["ID"];
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  fullName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  frontChannel?: Maybe<ContactFrontChannel>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  lead?: Maybe<Lead>;
  mHelpId?: Maybe<Scalars["String"]>;
  oldMongoId?: Maybe<Scalars["String"]>;
  referral?: Maybe<Referral>;
  activityFeed?: Maybe<Array<Maybe<Activity>>>;
  files?: Maybe<Array<Maybe<File>>>;
  outreachMedium?: Maybe<Scalars["String"]>;
  billingType?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
  stripeCustomer?: Maybe<Scalars["JSON"]>;
  stripePaymentMethods?: Maybe<Array<Maybe<Scalars["JSON"]>>>;
  fleet?: Maybe<FleetInfo>;
  taxExemptEin?: Maybe<Scalars["String"]>;
  isNubrakesCustomer?: Maybe<Scalars["Boolean"]>;
  followUpDate?: Maybe<Scalars["Date"]>;
};

export type ContactConnection = {
  __typename?: "ContactConnection";
  edges: Array<Contact>;
  pageInfo: PageInfo;
};

export type ContactFrontChannel = {
  __typename?: "ContactFrontChannel";
  channelId?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  allocatedAt?: Maybe<Scalars["Date"]>;
  allocationReason?: Maybe<Scalars["String"]>;
};

/** NUB-450 */
export type ContactTaxExemptionUpdateResult = {
  __typename?: "ContactTaxExemptionUpdateResult";
  contact: Contact;
  results: Array<TaxExemptionRepriceResult>;
};

export type ContactUsInput = {
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  businessName?: Maybe<Scalars["String"]>;
  numberOfVehicles?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  phoneNumber?: Maybe<Scalars["String"]>;
  message: Scalars["String"];
};

export enum ConvertExperiment {
  SuccessPageSocialProof = "successPageSocialProof",
  LeadFormSelfBooking = "leadFormSelfBooking",
}

export type Coupon = {
  __typename?: "Coupon";
  name: Scalars["String"];
  valid: Scalars["Boolean"];
  discount: EjiDiscount;
  createdBy?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  totalRedemptions?: Maybe<Scalars["Int"]>;
};

export type CouponInput = {
  name: Scalars["String"];
  valid: Scalars["Boolean"];
  discount: EjiDiscountInput;
  createdBy?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  totalRedemptions?: Maybe<Scalars["Int"]>;
};

export type CreateAirtableJobInput = {
  airtableServiceInfosInput?: Maybe<Array<Maybe<AirtableServiceInfoInput>>>;
  createJobInput?: Maybe<CreateJobInput>;
};

export type CreateAvailabilitySnapshotInput = {
  address: Scalars["String"];
  startTime: Scalars["Date"];
  laborTime: Scalars["Float"];
  contactId?: Maybe<Scalars["String"]>;
  estimateId?: Maybe<Scalars["String"]>;
  jobId?: Maybe<Scalars["String"]>;
};

export type CreateEstimateInput = {
  contact: Scalars["ID"];
  serviceLocation?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  status: Scalars["String"];
  market?: Maybe<Scalars["String"]>;
  issuedDate?: Maybe<Scalars["Date"]>;
  estimateNotes?: Maybe<Scalars["String"]>;
  serviceLocationNotes?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<Maybe<ItemInput>>>;
  taxable?: Maybe<Scalars["Boolean"]>;
  services?: Maybe<Array<Maybe<EjiServiceInput>>>;
  discounts?: Maybe<Array<Maybe<EjiDiscountInput>>>;
  promoCodes?: Maybe<Array<Maybe<PromoCodeInput>>>;
  serviceCatalogueUsed?: Maybe<Scalars["String"]>;
  pricingConfig?: Maybe<EjiPricingConfigInput>;
  partsLeadTimeInDays?: Maybe<Scalars["Int"]>;
  callForPartsTicketNumber?: Maybe<Scalars["String"]>;
  partsNotes?: Maybe<Scalars["String"]>;
};

export type CreateFeedbackInput = {
  appName: Scalars["String"];
  feedback: Scalars["String"];
};

export type CreateFileInput = {
  contact: Scalars["ID"];
  fileName: Scalars["String"];
  path: Scalars["String"];
  caption?: Maybe<Scalars["String"]>;
  share?: Maybe<Scalars["Boolean"]>;
  url: Scalars["String"];
  jobId?: Maybe<Scalars["ID"]>;
  category?: Maybe<Scalars["String"]>;
};

export type CreateGblLocationInput = {
  storeID: Scalars["String"];
  name: Scalars["String"];
  slug?: Maybe<Scalars["String"]>;
  address: Scalars["String"];
  city: Scalars["String"];
  state: Scalars["String"];
  stateName: Scalars["String"];
  zip: Scalars["Int"];
  fullAddress?: Maybe<Scalars["String"]>;
  hours?: Maybe<GblLocationHoursInput>;
  services?: Maybe<Array<Scalars["String"]>>;
  mapUrl?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  isActive?: Maybe<Scalars["Boolean"]>;
};

export type CreateInquiryRequestInput = {
  fullName?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  windowUrl?: Maybe<Scalars["String"]>;
  queryParams?: Maybe<Scalars["JSON"]>;
  campaignQueryParams?: Maybe<Scalars["JSON"]>;
  source?: Maybe<Scalars["String"]>;
  hearAboutUs?: Maybe<Scalars["String"]>;
  symptoms?: Maybe<Scalars["String"]>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  vehicleId?: Maybe<Scalars["ID"]>;
  zip?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  serviceUrgency?: Maybe<Scalars["String"]>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  referrerSource?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  licensePlateState?: Maybe<Scalars["String"]>;
  vin?: Maybe<Scalars["String"]>;
  odometer?: Maybe<Scalars["String"]>;
  discardThickness?: Maybe<Scalars["Float"]>;
  frontRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  rearRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  extraInfo?: Maybe<Scalars["String"]>;
  frontPadLife?: Maybe<Scalars["String"]>;
  rearPadLife?: Maybe<Scalars["String"]>;
  context?: Maybe<Scalars["String"]>;
  fleet?: Maybe<FleetInfoInput>;
  frontBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  rearBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  customerExpectation?: Maybe<Scalars["String"]>;
  additionalNotes?: Maybe<Scalars["String"]>;
  outreachMedium?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
  testVariants?: Maybe<Array<Maybe<Scalars["String"]>>>;
  leadFormTestVariants?: Maybe<Array<Maybe<Scalars["String"]>>>;
  preferredContactMethod?: Maybe<Scalars["String"]>;
  convertExperimentsData?: Maybe<Scalars["JSON"]>;
  extraFields?: Maybe<Scalars["JSON"]>;
};

export type CreateInvoiceInput = {
  contact?: Maybe<Scalars["ID"]>;
  job?: Maybe<Scalars["ID"]>;
  estimate?: Maybe<Scalars["ID"]>;
  taxable?: Maybe<Scalars["Boolean"]>;
  technician?: Maybe<Scalars["ID"]>;
  status: Scalars["String"];
  serviceLocation?: Maybe<Scalars["String"]>;
  issuedDate?: Maybe<Scalars["Date"]>;
  market?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  items?: Maybe<Array<Maybe<ItemInput>>>;
  services?: Maybe<Array<Maybe<EjiServiceInput>>>;
  serviceCatalogueUsed?: Maybe<Scalars["String"]>;
  discounts?: Maybe<Array<Maybe<EjiDiscountInput>>>;
  promoCodes?: Maybe<Array<Maybe<PromoCodeInput>>>;
  customerMessage?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  preJobCheckList?: Maybe<PreJobCheckListInput>;
  preJobCheckListV2?: Maybe<PreJobCheckListV2Input>;
  pricingConfig?: Maybe<EjiPricingConfigInput>;
  serviceFollowUp?: Maybe<ServiceFollowUp>;
  proceedingWithRepairs?: Maybe<Scalars["Boolean"]>;
};

export type CreateJobInput = {
  contact?: Maybe<Scalars["ID"]>;
  contactCopy?: Maybe<Scalars["JSON"]>;
  estimate?: Maybe<Scalars["ID"]>;
  serviceLocation?: Maybe<Scalars["String"]>;
  serviceLocationZip?: Maybe<Scalars["String"]>;
  withdrawReason?: Maybe<Scalars["String"]>;
  withdrawExtraInfo?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
  zendeskTags?: Maybe<Array<Maybe<Scalars["String"]>>>;
  taxable?: Maybe<Scalars["Boolean"]>;
  type?: Maybe<Scalars["String"]>;
  serviceCallReason?: Maybe<Scalars["String"]>;
  serviceCallReasonExtraInfo?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  lockedTechnicianId?: Maybe<Scalars["ID"]>;
  specializedRequired?: Maybe<Scalars["Boolean"]>;
  inspectionRequired?: Maybe<Scalars["Boolean"]>;
  priority?: Maybe<Scalars["String"]>;
  jobName?: Maybe<Scalars["String"]>;
  jobNotes?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  serviceLocationNotes?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<Maybe<ItemInput>>>;
  services?: Maybe<Array<Maybe<EjiServiceInput>>>;
  discounts?: Maybe<Array<Maybe<EjiDiscountInput>>>;
  promoCodes?: Maybe<Array<Maybe<PromoCodeInput>>>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  vehicleId?: Maybe<Scalars["String"]>;
  testVariants?: Maybe<Array<Maybe<Scalars["String"]>>>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  partsInfo?: Maybe<PartsInfoInput>;
  preJobCheckList?: Maybe<PreJobCheckListInput>;
  preJobCheckListV2?: Maybe<PreJobCheckListV2Input>;
  reasonRescheduled?: Maybe<Scalars["String"]>;
  appointmentInfo?: Maybe<AppointmentInput>;
  jobCausedWarrantyCheck?: Maybe<Scalars["ID"]>;
  warrantyCheckReason?: Maybe<Scalars["String"]>;
  warrantyCheckTechReason?: Maybe<Scalars["String"]>;
  warrantyCheckTechReasonExtraInfo?: Maybe<Scalars["String"]>;
  jobCausedDiagnostic?: Maybe<Scalars["ID"]>;
  jobViocInspection?: Maybe<Scalars["ID"]>;
  jobViocBrakeRepair?: Maybe<Scalars["ID"]>;
  serviceCatalogueUsed?: Maybe<Scalars["String"]>;
  warrantyCheckReasonExtraInfo?: Maybe<Scalars["String"]>;
  partsStore?: Maybe<Scalars["ID"]>;
  partsLeadTimeInDays?: Maybe<Scalars["Int"]>;
  pricingConfig?: Maybe<EjiPricingConfigInput>;
  symptomDiagnosisCategory?: Maybe<Scalars["String"]>;
  earlyNotice?: Maybe<Scalars["Boolean"]>;
  locationType?: Maybe<Scalars["String"]>;
  serviceLocationAddress?: Maybe<LocationAddressInput>;
};

export type CreateLeadInput = {
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
  phoneNumber: Scalars["String"];
  preferredContactMethod?: Maybe<Scalars["String"]>;
  lead: LeadInput;
  referredById?: Maybe<Scalars["String"]>;
  outreachMedium?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
  stripeCustomer?: Maybe<Scalars["JSON"]>;
  stripePaymentMethods?: Maybe<Array<Maybe<Scalars["JSON"]>>>;
  fleet?: Maybe<FleetInfoInput>;
  taxExemptEin?: Maybe<Scalars["String"]>;
};

export type CreateMarketInput = {
  name: Scalars["String"];
  timeZone?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  businessID?: Maybe<Scalars["String"]>;
  activeServiceArea?: Maybe<Scalars["JSON"]>;
  activeServiceAreaGeoJson?: Maybe<Scalars["JSON"]>;
  marketStatus?: Maybe<MarketStatusEnum>;
  visitBalanceCoefficient?: Maybe<Scalars["Float"]>;
  traffic?: Maybe<Scalars["String"]>;
  maxVisitLateness?: Maybe<Scalars["Int"]>;
  maxVehicleOvertime?: Maybe<Scalars["Int"]>;
  marketArea?: Maybe<Scalars["JSON"]>;
  marketAreaGeoJson?: Maybe<Scalars["JSON"]>;
  padsPricingVariance?: Maybe<MarketPricingVarianceInput>;
  rotorsPricingVariance?: Maybe<MarketPricingVarianceInput>;
  shoesPricingVariance?: Maybe<MarketPricingVarianceInput>;
  drumsPricingVariance?: Maybe<MarketPricingVarianceInput>;
  variance?: Maybe<MarketVarianceInput>;
  salesTaxType?: Maybe<Scalars["String"]>;
  partsTaxRate?: Maybe<Scalars["Float"]>;
  laborTaxRate?: Maybe<Scalars["Float"]>;
  laborRate?: Maybe<Scalars["Currency"]>;
  vendorUnitCostMultipliers?: Maybe<Array<Maybe<VendorUnitCostMultiplierInput>>>;
};

export type CreatePartOrderInput = {
  job?: Maybe<Scalars["ID"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  store?: Maybe<Scalars["ID"]>;
  partsLocation?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  orderTotalCost?: Maybe<Scalars["Float"]>;
  orderMethod?: Maybe<Scalars["String"]>;
  partOrderingIssue?: Maybe<Scalars["String"]>;
  partOrderingIssueNotes?: Maybe<Scalars["String"]>;
  cancelationDetails?: Maybe<CancelationDetailsInput>;
  items?: Maybe<Array<Maybe<CreatePartOrderItemWithoutPartOrderInput>>>;
};

export type CreatePartOrderItemInput = {
  partOrder: Scalars["ID"];
  units?: Maybe<Scalars["Float"]>;
  vendorUnitCost?: Maybe<Scalars["Float"]>;
  partNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PartOrderItemStatus>;
  ejiItem?: Maybe<Scalars["ID"]>;
};

export type CreatePartOrderItemWithoutPartOrderInput = {
  units?: Maybe<Scalars["Float"]>;
  vendorUnitCost?: Maybe<Scalars["Float"]>;
  partNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PartOrderItemStatus>;
  ejiItem?: Maybe<Scalars["ID"]>;
};

export type CreatePaymentInput = {
  paymentIntentId?: Maybe<Scalars["String"]>;
  type: Scalars["String"];
  invoice?: Maybe<Scalars["ID"]>;
  contact?: Maybe<Scalars["ID"]>;
  job?: Maybe<Scalars["ID"]>;
  customer?: Maybe<Scalars["ID"]>;
  stripePaymentMethod?: Maybe<Scalars["ID"]>;
  sendReceipt: Scalars["Boolean"];
  source?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
  receivedDate: Scalars["Date"];
  payer?: Maybe<Scalars["String"]>;
  amount: Scalars["Currency"];
  invoicePrice?: Maybe<Scalars["Currency"]>;
  partsCost?: Maybe<Scalars["Currency"]>;
  laborCost?: Maybe<Scalars["Currency"]>;
  subTotal?: Maybe<Scalars["Currency"]>;
  partsTotal?: Maybe<Scalars["Currency"]>;
  laborTotal?: Maybe<Scalars["Currency"]>;
  feesTotal?: Maybe<Scalars["Currency"]>;
  discountTotal?: Maybe<Scalars["Currency"]>;
  finalPartsTotal?: Maybe<Scalars["Currency"]>;
  finalLaborTotal?: Maybe<Scalars["Currency"]>;
  finalFeesTotal?: Maybe<Scalars["Currency"]>;
  finalSubTotal?: Maybe<Scalars["Currency"]>;
  partsTax?: Maybe<Scalars["Currency"]>;
  laborTax?: Maybe<Scalars["Currency"]>;
  totalTax?: Maybe<Scalars["Currency"]>;
  paymentMethod: Scalars["String"];
  memo?: Maybe<Scalars["String"]>;
  tip?: Maybe<Scalars["Currency"]>;
  refNumber?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["String"]>;
  transactionId?: Maybe<Scalars["String"]>;
};

export type CreatePaymentInputHoldCard = {
  paymentIntentId?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  invoice?: Maybe<Scalars["ID"]>;
  contact: Scalars["ID"];
  partsCost?: Maybe<Scalars["Currency"]>;
  laborCost?: Maybe<Scalars["Currency"]>;
  subTotal?: Maybe<Scalars["Currency"]>;
  partsTotal?: Maybe<Scalars["Currency"]>;
  laborTotal?: Maybe<Scalars["Currency"]>;
  feesTotal?: Maybe<Scalars["Currency"]>;
  discountTotal?: Maybe<Scalars["Currency"]>;
  finalPartsTotal?: Maybe<Scalars["Currency"]>;
  finalLaborTotal?: Maybe<Scalars["Currency"]>;
  finalFeesTotal?: Maybe<Scalars["Currency"]>;
  finalSubTotal?: Maybe<Scalars["Currency"]>;
  partsTax?: Maybe<Scalars["Currency"]>;
  laborTax?: Maybe<Scalars["Currency"]>;
  totalTax?: Maybe<Scalars["Currency"]>;
  job: Scalars["ID"];
  sendReceipt?: Maybe<Scalars["Boolean"]>;
  source?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
  receivedDate?: Maybe<Scalars["Date"]>;
  payer?: Maybe<Scalars["String"]>;
  amount: Scalars["Currency"];
  invoicePrice?: Maybe<Scalars["Currency"]>;
  paymentMethod?: Maybe<Scalars["String"]>;
  memo?: Maybe<Scalars["String"]>;
  tip?: Maybe<Scalars["Currency"]>;
  refNumber?: Maybe<Scalars["String"]>;
};

export type CreatePaymentIntentInput = {
  amount: Scalars["Currency"];
  paymentMethodTypes: Array<Maybe<Scalars["String"]>>;
  invoiceId: Scalars["String"];
};

export type CreateProductInput = {
  name: Scalars["String"];
  laborCost: Scalars["Currency"];
  partsCost: Scalars["Currency"];
  amount: Scalars["Currency"];
  description?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type CreateProductSetInput = {
  name: Scalars["String"];
  products: Array<Scalars["ID"]>;
  description?: Maybe<Scalars["String"]>;
};

export type CreateSelfRescheduleRequest = {
  address: Scalars["String"];
  startTimeRange: StartTimeRangeInput;
  jobId: Scalars["String"];
  estimateId?: Maybe<Scalars["String"]>;
  laborTime?: Maybe<Scalars["Int"]>;
  contactUpdates?: Maybe<SelfScheduleContactUpdate>;
  vehicleInfo?: Maybe<SelfScheduleVehicleInfo>;
  appointmentSubject?: Maybe<Scalars["String"]>;
  earlyNotice?: Maybe<Scalars["Boolean"]>;
  locationType?: Maybe<Scalars["String"]>;
  isPriority?: Maybe<Scalars["Boolean"]>;
  vehicleMistmatch?: Maybe<Scalars["Boolean"]>;
};

export type CreateSelfScheduleRequest = {
  address: Scalars["String"];
  startTimeRange: StartTimeRangeInput;
  identifier: Scalars["String"];
  jobId: Scalars["String"];
  estimateId?: Maybe<Scalars["String"]>;
  laborTime?: Maybe<Scalars["Int"]>;
  contactUpdates?: Maybe<SelfScheduleContactUpdate>;
  vehicleInfo?: Maybe<SelfScheduleVehicleInfo>;
  appointmentSubject?: Maybe<Scalars["String"]>;
  earlyNotice?: Maybe<Scalars["Boolean"]>;
  locationType?: Maybe<Scalars["String"]>;
  isPriority?: Maybe<Scalars["Boolean"]>;
  vehicleMistmatch?: Maybe<Scalars["Boolean"]>;
};

export type CreateTechnicianInput = {
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  email: Scalars["String"];
  market: Scalars["String"];
  phoneNumber: Scalars["String"];
  isActive?: Maybe<Scalars["Boolean"]>;
  isVirtual?: Maybe<Scalars["Boolean"]>;
  isEllegibleToViocInspection?: Maybe<Scalars["Boolean"]>;
  is1099?: Maybe<Scalars["Boolean"]>;
  payMultiplier?: Maybe<Scalars["Float"]>;
  capacity?: Maybe<Scalars["Int"]>;
  capacityOverrides?: Maybe<Array<Maybe<TechnicianCapacityOverrideInput>>>;
  speed?: Maybe<Scalars["Float"]>;
  specializedServices?: Maybe<Scalars["Boolean"]>;
  role: Scalars["ID"];
  roleCopy?: Maybe<Scalars["JSON"]>;
  password: Scalars["String"];
  confirmPassword: Scalars["String"];
  preferences?: Maybe<TechnicianPreferencesInput>;
  timeZone?: Maybe<Scalars["String"]>;
  homePartsStore?: Maybe<Scalars["ID"]>;
  whenIWorkUserId?: Maybe<Scalars["String"]>;
  schedulingDays?: Maybe<Array<Maybe<SchedulingDayInput>>>;
  onWayMessage?: Maybe<Scalars["String"]>;
  serviceAreaAnchorAddress?: Maybe<Scalars["String"]>;
  homeAddress?: Maybe<Scalars["String"]>;
};

export type CreateUserInput = {
  email: Scalars["String"];
  firstName: Scalars["String"];
  lastName: Scalars["String"];
  password: Scalars["String"];
  role?: Maybe<UserRole>;
};

export type CreateViocInspectionInquiryRequestInput = {
  fullName?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  queryParams?: Maybe<Scalars["JSON"]>;
  extraFields?: Maybe<Scalars["JSON"]>;
  windowUrl?: Maybe<Scalars["String"]>;
  leadFormTestVariants?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type CreateViocInspectionInquiryRequestResult = {
  __typename?: "CreateViocInspectionInquiryRequestResult";
  inquiryRequestId?: Maybe<Scalars["String"]>;
  contactId?: Maybe<Scalars["String"]>;
  jobId?: Maybe<Scalars["String"]>;
};

export type CreateViocLeadInput = {
  phoneNumber?: Maybe<Scalars["String"]>;
  windowUrl?: Maybe<Scalars["String"]>;
  queryParams?: Maybe<Scalars["JSON"]>;
  extraFields?: Maybe<Scalars["JSON"]>;
};

export type CreateViocSelfScheduleRequest = {
  address: Scalars["String"];
  startTimeRange: StartTimeRangeInput;
  jobId: Scalars["String"];
  estimateId?: Maybe<Scalars["String"]>;
  laborTime?: Maybe<Scalars["Int"]>;
  contactUpdates?: Maybe<SelfScheduleContactUpdate>;
  vehicleInfo?: Maybe<SelfScheduleVehicleInfo>;
  appointmentSubject?: Maybe<Scalars["String"]>;
  VIOCSymptoms?: Maybe<Scalars["Boolean"]>;
  vehicleMistmatch?: Maybe<Scalars["Boolean"]>;
};

export type CustomerContact = {
  __typename?: "CustomerContact";
  id?: Maybe<Scalars["ID"]>;
};

export type CustomerGetInvoiceResult = InvoicePaidResult | CustomerInvoice;

export type CustomerInvoice = {
  __typename?: "CustomerInvoice";
  id: Scalars["ID"];
  invoiceNumber?: Maybe<Scalars["String"]>;
  contact?: Maybe<Contact>;
  status: Scalars["String"];
  serviceLocation?: Maybe<Scalars["String"]>;
  issuedDate?: Maybe<Scalars["Date"]>;
  market?: Maybe<Scalars["String"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  items?: Maybe<Array<Maybe<Item>>>;
  amountPaid?: Maybe<Scalars["Currency"]>;
  subTotal?: Maybe<Scalars["Currency"]>;
  total?: Maybe<Scalars["Currency"]>;
  balanceDue?: Maybe<Scalars["Currency"]>;
};

export type CustomerJob = {
  __typename?: "CustomerJob";
  id?: Maybe<Scalars["ID"]>;
};

export type DiagnosticInfo = {
  __typename?: "DiagnosticInfo";
  diagnosticCategory?: Maybe<Scalars["String"]>;
  checklistInfo?: Maybe<Scalars["JSON"]>;
};

export type DiagnosticsQuestionAnswer = {
  __typename?: "DiagnosticsQuestionAnswer";
  question: Scalars["String"];
  answer?: Maybe<Scalars["String"]>;
  relatedSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type DiagnosticsQuestionAnswerInput = {
  question: Scalars["String"];
  answer?: Maybe<Scalars["String"]>;
  relatedSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type DiscountInput = {
  type: Scalars["String"];
  value: Scalars["Float"];
  label?: Maybe<Scalars["String"]>;
};

export type DiscountTireContactUsInput = {
  name: Scalars["String"];
  email: Scalars["String"];
  phoneNumber: Scalars["String"];
  metro: Scalars["String"];
  inquiry: Scalars["String"];
  dtAccountNumber?: Maybe<Scalars["String"]>;
  appointmentRequestDate?: Maybe<Scalars["Date"]>;
};

export type DiscountTireContactUsResult = {
  __typename?: "DiscountTireContactUsResult";
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  metro?: Maybe<Scalars["String"]>;
  inquiry?: Maybe<Scalars["String"]>;
  dtAccountNumber?: Maybe<Scalars["String"]>;
  appointmentRequestDate?: Maybe<Scalars["Date"]>;
};

export type DiscountType = {
  __typename?: "DiscountType";
  type: Scalars["String"];
  value: Scalars["Float"];
  label?: Maybe<Scalars["String"]>;
};

export type DispatchCapacity = {
  __typename?: "DispatchCapacity";
  scheduled: Scalars["Int"];
  available: Scalars["Int"];
  remaining: Scalars["Int"];
};

export type DispatchDayPrep = {
  __typename?: "DispatchDayPrep";
  market: Scalars["String"];
  date: Scalars["String"];
  jobCount: Scalars["Int"];
  jobTypeBreakdown: DispatchJobTypeBreakdown;
  jobsWithPartsOrdered: Scalars["Int"];
  pctJobsWithPartsOrdered: Scalars["Float"];
  outstandingPartsDueCount: Scalars["Int"];
  capacity: DispatchCapacity;
  jobs?: Maybe<Array<Maybe<Job>>>;
};

export type DispatchJobTypeBreakdown = {
  __typename?: "DispatchJobTypeBreakdown";
  brake: Scalars["Int"];
  vioc: Scalars["Int"];
  warranty: Scalars["Int"];
  other: Scalars["Int"];
};

export type DistanceData = {
  __typename?: "DistanceData";
  distance?: Maybe<Scalars["JSON"]>;
  duration?: Maybe<Scalars["JSON"]>;
  status?: Maybe<Scalars["String"]>;
};

export type DocumentToSign = {
  __typename?: "DocumentToSign";
  slug?: Maybe<Scalars["String"]>;
};

export type DriveTime = {
  __typename?: "DriveTime";
  origin?: Maybe<Scalars["String"]>;
  destination?: Maybe<Scalars["String"]>;
  durationInSeconds?: Maybe<Scalars["Float"]>;
  durationWithTrafficInSeconds?: Maybe<Scalars["Float"]>;
  distanceInMeters?: Maybe<Scalars["Float"]>;
  readableDuration?: Maybe<Scalars["String"]>;
  readableDurationWithTraffic?: Maybe<Scalars["String"]>;
  readableDistance?: Maybe<Scalars["String"]>;
  destinationType?: Maybe<Scalars["String"]>;
};

export type DriveTimes = {
  __typename?: "DriveTimes";
  arrival?: Maybe<DriveTime>;
  departure?: Maybe<DriveTime>;
};

export type EjiDiscount = {
  __typename?: "EJIDiscount";
  type: Scalars["String"];
  amount: Scalars["Float"];
  reason: Scalars["String"];
  total?: Maybe<Scalars["Currency"]>;
  id?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  packageDiscountCopy?: Maybe<PackageDiscountType>;
};

export type EjiDiscountInput = {
  type: Scalars["String"];
  amount: Scalars["Float"];
  reason: Scalars["String"];
  id?: Maybe<Scalars["String"]>;
  label?: Maybe<Scalars["String"]>;
  packageDiscountCopy?: Maybe<PackageDiscountInput>;
};

export type EjiItem = {
  __typename?: "EJIItem";
  id: Scalars["ID"];
  serviceProductId: Scalars["ID"];
  productSelection?: Maybe<ProductSelection>;
  type: Scalars["String"];
  units?: Maybe<Scalars["Float"]>;
  overriddenCustomerPrice: Scalars["Boolean"];
  customerPrice: Scalars["Currency"];
  vendorUnitCost?: Maybe<Scalars["Currency"]>;
  expectedVendorUnitCost?: Maybe<Scalars["Currency"]>;
  behavior: Scalars["String"];
  category: Scalars["String"];
  notes?: Maybe<Scalars["String"]>;
  orderItem?: Maybe<PartOrderItem>;
  partItem?: Maybe<PartOrderItem>;
  marketVendorUnitCostMultiplierUsed?: Maybe<Scalars["Float"]>;
  marketLaborRateUsed?: Maybe<Scalars["Currency"]>;
  jobItem?: Maybe<PartOrderItemV2>;
  warranty_replacement_reason?: Maybe<Scalars["String"]>;
  warranty_replacement_upgrade?: Maybe<Scalars["Boolean"]>;
};

export type EjiItemInput = {
  _id?: Maybe<Scalars["ID"]>;
  serviceProductId: Scalars["ID"];
  productSelection?: Maybe<ProductSelectionInput>;
  type: Scalars["String"];
  units?: Maybe<Scalars["Float"]>;
  overriddenCustomerPrice: Scalars["Boolean"];
  customerPrice: Scalars["Currency"];
  vendorUnitCost?: Maybe<Scalars["Currency"]>;
  expectedVendorUnitCost?: Maybe<Scalars["Currency"]>;
  behavior: Scalars["String"];
  category: Scalars["String"];
  notes?: Maybe<Scalars["String"]>;
  orderItem?: Maybe<PartOrderItemInput>;
  partItem?: Maybe<Scalars["ID"]>;
  marketVendorUnitCostMultiplierUsed?: Maybe<Scalars["Float"]>;
  marketLaborRateUsed?: Maybe<Scalars["Currency"]>;
  jobItem?: Maybe<Scalars["ID"]>;
  warranty_replacement_reason?: Maybe<Scalars["String"]>;
  warranty_replacement_upgrade?: Maybe<Scalars["Boolean"]>;
};

export type EjiPriceInfo = {
  __typename?: "EJIPriceInfo";
  pricingConfig?: Maybe<EjiPricingConfig>;
  partsTotal?: Maybe<Scalars["Currency"]>;
  laborTotal?: Maybe<Scalars["Currency"]>;
  feesTotal?: Maybe<Scalars["Currency"]>;
  subTotal?: Maybe<Scalars["Currency"]>;
  discounts?: Maybe<Array<Maybe<EjiDiscount>>>;
  promoCodes?: Maybe<Array<Maybe<PromoCode>>>;
  discountTotal?: Maybe<Scalars["Currency"]>;
  promoCodeDiscountTotal?: Maybe<Scalars["Currency"]>;
  combinedDiscountTotal?: Maybe<Scalars["Currency"]>;
  finalPartsTotal?: Maybe<Scalars["Currency"]>;
  finalLaborTotal?: Maybe<Scalars["Currency"]>;
  finalFeesTotal?: Maybe<Scalars["Currency"]>;
  finalSubTotal?: Maybe<Scalars["Currency"]>;
  partsTax?: Maybe<Scalars["Currency"]>;
  laborTax?: Maybe<Scalars["Currency"]>;
  totalTax?: Maybe<Scalars["Currency"]>;
  amountDue?: Maybe<Scalars["Currency"]>;
  calculatedTaxRate?: Maybe<Scalars["Float"]>;
  taxjarLaborTaxRate?: Maybe<Scalars["Float"]>;
  taxjarPartsTaxRate?: Maybe<Scalars["Float"]>;
  taxjarPayload?: Maybe<Scalars["String"]>;
  /**
   * Provenance of the tax figures on this priceInfo (see TaxSource). Computed on read:
   * CALCULATED when TaxJar ran (taxjarPayload present), ESTIMATED when only a market
   * fallback rate was applied, TBC when no TaxJar and no fallback rate.
   */
  taxSource?: Maybe<TaxSource>;
  taxAudit?: Maybe<TaxAudit>;
};

export type EjiPricingConfig = {
  __typename?: "EJIPricingConfig";
  laborRate?: Maybe<Scalars["Currency"]>;
  vendorUnitCostMultipliers?: Maybe<Array<Maybe<VendorUnitCostMultiplier>>>;
};

export type EjiPricingConfigInput = {
  laborRate?: Maybe<Scalars["Currency"]>;
  vendorUnitCostMultipliers?: Maybe<Array<Maybe<VendorUnitCostMultiplierInput>>>;
};

export type EjiService = {
  __typename?: "EJIService";
  id: Scalars["ID"];
  service: Scalars["ID"];
  name: Scalars["String"];
  inEstimate: Scalars["Boolean"];
  customerPrice: Scalars["Currency"];
  technicianPay: Scalars["Currency"];
  items: Array<Maybe<EjiItem>>;
  updatedAt?: Maybe<Scalars["Date"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  partsCalcs?: Maybe<PartsCalcs>;
  diagnosticInfo?: Maybe<DiagnosticInfo>;
  approvalStatus?: Maybe<Scalars["String"]>;
};

export type EjiServiceInput = {
  service: Scalars["ID"];
  name: Scalars["String"];
  inEstimate: Scalars["Boolean"];
  technicianPay: Scalars["Currency"];
  partsCalcs?: Maybe<PartsCalcsInput>;
  items: Array<Maybe<EjiItemInput>>;
  approvalStatus?: Maybe<Scalars["String"]>;
};

export type Estimate = {
  __typename?: "Estimate";
  id: Scalars["ID"];
  estimateNumber?: Maybe<Scalars["String"]>;
  contact?: Maybe<Contact>;
  issuedDate?: Maybe<Scalars["Date"]>;
  taxable?: Maybe<Scalars["Boolean"]>;
  estimateNotes?: Maybe<Scalars["String"]>;
  serviceLocationNotes?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfo>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptom>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  price?: Maybe<Scalars["Currency"]>;
  market?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
  serviceLocation?: Maybe<Scalars["String"]>;
  job?: Maybe<Job>;
  items?: Maybe<Array<Maybe<Item>>>;
  services?: Maybe<Array<Maybe<EjiService>>>;
  serviceCatalogueUsed?: Maybe<Scalars["String"]>;
  priceInfo?: Maybe<EjiPriceInfo>;
  createdBy?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  activityFeed?: Maybe<Array<Maybe<Activity>>>;
  partsLeadTimeInDays?: Maybe<Scalars["Int"]>;
  callForPartsTicketNumber?: Maybe<Scalars["String"]>;
  partsNotes?: Maybe<Scalars["String"]>;
};

export type EstimatesConnection = {
  __typename?: "EstimatesConnection";
  edges: Array<Estimate>;
  pageInfo?: Maybe<PageInfo>;
};

export type Event = {
  __typename?: "Event";
  event: Scalars["String"];
  error?: Maybe<Scalars["JSON"]>;
  data?: Maybe<Scalars["JSON"]>;
};

export type ExistingAppointment = {
  __typename?: "ExistingAppointment";
  startDate?: Maybe<Scalars["Date"]>;
  endDate?: Maybe<Scalars["Date"]>;
  serviceLocation?: Maybe<Scalars["String"]>;
};

export type ExternalServiceHistoryType = {
  __typename?: "ExternalServiceHistoryType";
  source?: Maybe<Scalars["String"]>;
  displayDate?: Maybe<Scalars["String"]>;
  text?: Maybe<Array<Maybe<Scalars["String"]>>>;
  displayText?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  odometer?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
};

export type File = {
  __typename?: "File";
  fileName?: Maybe<Scalars["String"]>;
  caption?: Maybe<Scalars["String"]>;
  share?: Maybe<Scalars["Boolean"]>;
  path?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  jobId?: Maybe<Scalars["ID"]>;
  category?: Maybe<Scalars["String"]>;
  signedUrl?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
};

export type FileInput = {
  fileName: Scalars["String"];
  path: Scalars["String"];
  caption?: Maybe<Scalars["String"]>;
  share?: Maybe<Scalars["Boolean"]>;
  url: Scalars["String"];
  jobId?: Maybe<Scalars["ID"]>;
  category?: Maybe<Scalars["String"]>;
};

export type FleetInfo = {
  __typename?: "FleetInfo";
  name?: Maybe<Scalars["String"]>;
  organizationId?: Maybe<Scalars["String"]>;
};

export type FleetInfoInput = {
  name?: Maybe<Scalars["String"]>;
  organizationId?: Maybe<Scalars["String"]>;
};

export type FleetRequest = {
  __typename?: "FleetRequest";
  _id: Scalars["ID"];
  contact: Contact;
  vehiclesWithServices: Array<Maybe<VehicleWithServices>>;
  preferredDate?: Maybe<Scalars["Date"]>;
  preferredTime?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
};

export type FrontInput = {
  id: Scalars["String"];
};

export type GblLocation = {
  __typename?: "GblLocation";
  id: Scalars["ID"];
  storeID: Scalars["String"];
  name: Scalars["String"];
  slug: Scalars["String"];
  address: Scalars["String"];
  city: Scalars["String"];
  state: Scalars["String"];
  stateName: Scalars["String"];
  zip: Scalars["Int"];
  fullAddress: Scalars["String"];
  hours: GblLocationHours;
  services: Array<Scalars["String"]>;
  mapUrl?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  isActive: Scalars["Boolean"];
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
};

export type GblLocationHours = {
  __typename?: "GblLocationHours";
  weekday?: Maybe<Scalars["String"]>;
  saturday?: Maybe<Scalars["String"]>;
  sunday?: Maybe<Scalars["String"]>;
};

export type GblLocationHoursInput = {
  weekday?: Maybe<Scalars["String"]>;
  saturday?: Maybe<Scalars["String"]>;
  sunday?: Maybe<Scalars["String"]>;
};

export type GenerateJobDiagnosticsSummaryInput = {
  jobId: Scalars["ID"];
};

export type GenerateLeadFormEstimateResult = {
  __typename?: "GenerateLeadFormEstimateResult";
  jobId: Scalars["ID"];
  eligible: Scalars["Boolean"];
  notes?: Maybe<Array<Maybe<Scalars["String"]>>>;
  services?: Maybe<Array<Maybe<EjiService>>>;
  priceInfo?: Maybe<EjiPriceInfo>;
  selfSchedulingLink?: Maybe<Scalars["String"]>;
};

export type GenerateServicesInput = {
  year?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  market: Scalars["String"];
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  jobId?: Maybe<Scalars["String"]>;
  useMultiplePartOrders?: Maybe<Scalars["Boolean"]>;
};

export type GenerateServicesResult = {
  __typename?: "GenerateServicesResult";
  priceResult?: Maybe<PossibleEjiPriceResult>;
  events?: Maybe<Array<Maybe<Event>>>;
};

export type GenerateViocJobServicesResult = {
  __typename?: "GenerateViocJobServicesResult";
  jobId: Scalars["ID"];
  servicesGenerated: Scalars["Int"];
  vehicleType?: Maybe<Scalars["String"]>;
  /**
   * False when the vehicle must not be quoted (exception vehicle, no vehicle data,
   * or parts could not be assigned) and the customer is handed off to sales.
   */
  quotable: Scalars["Boolean"];
};

export type GeocodeInput = {
  lat?: Maybe<Scalars["Float"]>;
  lng?: Maybe<Scalars["Float"]>;
};

export type GetAQuoteInput = {
  fullName?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  queryParams?: Maybe<Scalars["JSON"]>;
  source?: Maybe<Scalars["String"]>;
  hearAboutUs?: Maybe<Scalars["String"]>;
  symptoms?: Maybe<Scalars["String"]>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  zip?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  serviceUrgency?: Maybe<Scalars["String"]>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  referrerSource?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  leadFormTestVariants?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type GetAQuoteResult = {
  __typename?: "GetAQuoteResult";
  jobId: Scalars["ID"];
  inquiryRequestId?: Maybe<Scalars["ID"]>;
  contactId?: Maybe<Scalars["ID"]>;
  selfBookingData: SelfBookingData;
};

export type GetAllPossibleServicesInput = {
  inEstimate?: Maybe<Scalars["Boolean"]>;
};

export type GetAppointmentSuggestionsInput = {
  address: Scalars["String"];
  startTime: Scalars["Date"];
  endTime: Scalars["Date"];
  laborTime: Scalars["Float"];
  contactId?: Maybe<Scalars["String"]>;
  estimateId?: Maybe<Scalars["String"]>;
  jobId?: Maybe<Scalars["String"]>;
  jobCustomerType?: Maybe<Scalars["String"]>;
  technicianPartsStoreId?: Maybe<Scalars["String"]>;
};

export type GetAvailabilityInput = {
  address: Scalars["String"];
  zip?: Maybe<Scalars["String"]>;
  startTimeRange: StartTimeRangeInput;
  laborTime: Scalars["Float"];
  contactId?: Maybe<Scalars["String"]>;
  estimateId?: Maybe<Scalars["String"]>;
  jobId?: Maybe<Scalars["String"]>;
  partsLeadTimeInDays?: Maybe<Scalars["Int"]>;
};

export type GetAvailabilityRes = {
  __typename?: "GetAvailabilityRes";
  possibleAppointmentStartTimes: Array<Maybe<StartTimeRange>>;
  availableWindows: Array<Maybe<AvailabilityWindow>>;
  availabilitySnapshotId?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
};

export type GetDefaultServicesInput = {
  year?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  market: Scalars["String"];
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
};

export type GetPossibleServiceInput = {
  name: Scalars["String"];
  inEstimate?: Maybe<Scalars["Boolean"]>;
};

export type GetVehicleServiceExceptionInput = {
  year: Scalars["Int"];
  make: Scalars["String"];
  model: Scalars["String"];
  submodel?: Maybe<Scalars["String"]>;
};

export type GetViocAvailabilityInput = {
  address: Scalars["String"];
  zip?: Maybe<Scalars["String"]>;
  laborTime: Scalars["Float"];
  contactId?: Maybe<Scalars["String"]>;
  estimateId?: Maybe<Scalars["String"]>;
  jobId?: Maybe<Scalars["String"]>;
};

export type GetViocAvailabilityRes = {
  __typename?: "GetViocAvailabilityRes";
  market?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
};

export type InquiryRequest = {
  __typename?: "InquiryRequest";
  id: Scalars["ID"];
  fullName?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  queryParams?: Maybe<Scalars["JSON"]>;
  campaignQueryParams?: Maybe<Scalars["JSON"]>;
  source?: Maybe<Scalars["String"]>;
  hearAboutUs?: Maybe<Scalars["String"]>;
  symptoms?: Maybe<Scalars["String"]>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptom>>>;
  zip?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  serviceUrgency?: Maybe<Scalars["String"]>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  referrerSource?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  licensePlateState?: Maybe<Scalars["String"]>;
  vin?: Maybe<Scalars["String"]>;
  odometer?: Maybe<Scalars["String"]>;
  discardThickness?: Maybe<Scalars["Float"]>;
  frontRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  rearRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  extraInfo?: Maybe<Scalars["String"]>;
  frontPadLife?: Maybe<Scalars["String"]>;
  rearPadLife?: Maybe<Scalars["String"]>;
  context?: Maybe<Scalars["String"]>;
  frontBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  rearBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  customerExpectation?: Maybe<Scalars["String"]>;
  additionalNotes?: Maybe<Scalars["String"]>;
  fleet?: Maybe<FleetInfo>;
  convertExperimentsData?: Maybe<Scalars["JSON"]>;
};

export type InquiryRequestV2 = {
  __typename?: "InquiryRequestV2";
  inquiryRequest?: Maybe<InquiryRequest>;
  customerContact?: Maybe<CustomerContact>;
  customerJob?: Maybe<CustomerJob>;
  market?: Maybe<Scalars["String"]>;
  selfBookingEligibilityDecided?: Maybe<Scalars["Boolean"]>;
};

export type Invoice = {
  __typename?: "Invoice";
  id: Scalars["ID"];
  invoiceNumber?: Maybe<Scalars["String"]>;
  contact?: Maybe<Contact>;
  job?: Maybe<Job>;
  partsCost?: Maybe<Scalars["Currency"]>;
  laborCost?: Maybe<Scalars["Currency"]>;
  partsTax?: Maybe<Scalars["Currency"]>;
  laborTax?: Maybe<Scalars["Currency"]>;
  totalTax?: Maybe<Scalars["Currency"]>;
  estimate?: Maybe<Estimate>;
  technician?: Maybe<Technician>;
  taxable?: Maybe<Scalars["Boolean"]>;
  status: Scalars["String"];
  serviceLocation?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  issuedDate?: Maybe<Scalars["Date"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  mHelpId?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<Maybe<Item>>>;
  services?: Maybe<Array<Maybe<EjiService>>>;
  priceInfo?: Maybe<EjiPriceInfo>;
  serviceCatalogueUsed?: Maybe<Scalars["String"]>;
  customerMessage?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfo>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptom>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  amountPaid?: Maybe<Scalars["Currency"]>;
  subTotal?: Maybe<Scalars["Currency"]>;
  total?: Maybe<Scalars["Currency"]>;
  balanceDue?: Maybe<Scalars["Currency"]>;
  activityFeed?: Maybe<Array<Maybe<Activity>>>;
  preJobCheckList?: Maybe<PreJobCheckList>;
  preJobCheckListV2?: Maybe<PreJobCheckListV2>;
  createdBy?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  serviceFollowUp?: Maybe<ServiceFollowUpInfo>;
  proceedingWithRepairs?: Maybe<Scalars["Boolean"]>;
  isPaid?: Maybe<Scalars["Boolean"]>;
  reviewShortcode?: Maybe<Scalars["String"]>;
};

export type InvoiceConnection = {
  __typename?: "InvoiceConnection";
  edges: Array<Invoice>;
  pageInfo?: Maybe<PageInfo>;
};

export type InvoiceJobComparison = {
  __typename?: "InvoiceJobComparison";
  jobTaxjarPartsTaxRate?: Maybe<Scalars["Float"]>;
  jobTaxjarLaborTaxRate?: Maybe<Scalars["Float"]>;
  jobPartsTax?: Maybe<Scalars["Float"]>;
  jobLaborTax?: Maybe<Scalars["Float"]>;
  jobTotalTax?: Maybe<Scalars["Float"]>;
  partsRateMatch?: Maybe<Scalars["Boolean"]>;
  laborRateMatch?: Maybe<Scalars["Boolean"]>;
  partsTaxMatch?: Maybe<Scalars["Boolean"]>;
  laborTaxMatch?: Maybe<Scalars["Boolean"]>;
  totalTaxMatch?: Maybe<Scalars["Boolean"]>;
};

export type InvoicePaidResult = {
  __typename?: "InvoicePaidResult";
  id: Scalars["ID"];
  status: Scalars["String"];
};

/** NUB-450 */
export type InvoiceTaxRecalculationPreview = {
  __typename?: "InvoiceTaxRecalculationPreview";
  invoiceId: Scalars["ID"];
  editable: Scalars["Boolean"];
  taxExempt: Scalars["Boolean"];
  currentTaxable: Scalars["Boolean"];
  newTaxable: Scalars["Boolean"];
  currentAmountDue?: Maybe<Scalars["Currency"]>;
  newAmountDue?: Maybe<Scalars["Currency"]>;
  currentTotalTax?: Maybe<Scalars["Currency"]>;
  newTotalTax?: Maybe<Scalars["Currency"]>;
};

export type Item = {
  __typename?: "Item";
  name: Scalars["String"];
  product?: Maybe<Scalars["ID"]>;
  partsStore?: Maybe<PartsStore>;
  laborCost: Scalars["Currency"];
  partsCost: Scalars["Currency"];
  vendorPartsCost?: Maybe<Scalars["Currency"]>;
  amount: Scalars["Currency"];
  description?: Maybe<Scalars["String"]>;
  isInEstimate?: Maybe<Scalars["Boolean"]>;
  partNumber?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  jobItem?: Maybe<PartOrderItemV2>;
};

export type ItemInput = {
  product?: Maybe<Scalars["ID"]>;
  partsStore?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  amount: Scalars["Currency"];
  laborCost: Scalars["Currency"];
  partsCost: Scalars["Currency"];
  vendorPartsCost?: Maybe<Scalars["Currency"]>;
  partNumber?: Maybe<Scalars["String"]>;
  isInEstimate?: Maybe<Scalars["Boolean"]>;
  jobItem?: Maybe<Scalars["ID"]>;
};

export type Job = {
  __typename?: "Job";
  id: Scalars["ID"];
  invoice?: Maybe<Invoice>;
  jobNumber?: Maybe<Scalars["String"]>;
  contact?: Maybe<Contact>;
  feedback?: Maybe<JobFeedback>;
  partsOrderingIssuesSurvey?: Maybe<PartsOrderingIssuesSurvey>;
  partsOrderingIssuesSurveys?: Maybe<Array<Maybe<PartsOrderingIssuesSurvey>>>;
  serviceLocation?: Maybe<Scalars["String"]>;
  serviceLocationGeocode?: Maybe<Scalars["JSON"]>;
  serviceLocationZip?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
  isWithdrawn?: Maybe<Scalars["Boolean"]>;
  taxable?: Maybe<Scalars["Boolean"]>;
  type?: Maybe<Scalars["String"]>;
  serviceCallReason?: Maybe<Scalars["String"]>;
  serviceCallReasonExtraInfo?: Maybe<Scalars["String"]>;
  jobName?: Maybe<Scalars["String"]>;
  mHelpId?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  serviceLocationNotes?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<Maybe<Item>>>;
  approvalInfo?: Maybe<ApprovalInfo>;
  diagnosticJob?: Maybe<Job>;
  services?: Maybe<Array<Maybe<EjiService>>>;
  priceInfo?: Maybe<EjiPriceInfo>;
  serviceCatalogueUsed?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfo>;
  vehicleId?: Maybe<Scalars["ID"]>;
  serviceLocationAddress?: Maybe<LocationAddress>;
  lockedTechnicianId?: Maybe<Scalars["ID"]>;
  partStoreId?: Maybe<Scalars["ID"]>;
  specializedRequired?: Maybe<Scalars["Boolean"]>;
  inspectionRequired?: Maybe<Scalars["Boolean"]>;
  priority?: Maybe<Scalars["String"]>;
  testVariants?: Maybe<Array<Maybe<Scalars["String"]>>>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptom>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  partsInfo?: Maybe<PartsInfo>;
  preJobCheckList?: Maybe<PreJobCheckList>;
  preJobCheckListV2?: Maybe<PreJobCheckListV2>;
  appointment?: Maybe<Appointment>;
  activityFeed?: Maybe<Array<Maybe<Activity>>>;
  withdrawReason?: Maybe<Scalars["String"]>;
  withdrawExtraInfo?: Maybe<Scalars["String"]>;
  withdrawnAt?: Maybe<Scalars["Date"]>;
  estimate?: Maybe<Estimate>;
  createdBy?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  jobCausedWarrantyCheck?: Maybe<Job>;
  jobCausedDiagnostic?: Maybe<Job>;
  jobViocInspection?: Maybe<Job>;
  jobViocBrakeRepair?: Maybe<Job>;
  partsLeadTimeInDays?: Maybe<Scalars["Int"]>;
  warrantyCheckReason?: Maybe<Scalars["String"]>;
  warrantyCheckReasonExtraInfo?: Maybe<Scalars["String"]>;
  warrantyCheckTechReason?: Maybe<Scalars["String"]>;
  warrantyCheckTechReasonExtraInfo?: Maybe<Scalars["String"]>;
  partsStore?: Maybe<PartsStore>;
  pipedriveDealId?: Maybe<Scalars["String"]>;
  zendeskTags?: Maybe<Array<Maybe<Scalars["String"]>>>;
  diagnosticsQuestionsAnswers?: Maybe<Array<Maybe<DiagnosticsQuestionAnswer>>>;
  convertExperiments?: Maybe<JobConvertExperiments>;
  estimateSentAt?: Maybe<Scalars["Date"]>;
  symptomDiagnosisCategory?: Maybe<Scalars["String"]>;
  contactPaidInvoices?: Maybe<Scalars["Int"]>;
  viocStore?: Maybe<ViocStore>;
  locationType?: Maybe<Scalars["String"]>;
  earlyNotice?: Maybe<Scalars["Boolean"]>;
  selfBookingIdentifier?: Maybe<Scalars["String"]>;
  myAppointmentToken?: Maybe<Scalars["String"]>;
  postJobChecklist?: Maybe<PostJobChecklist>;
  hasPartIssue?: Maybe<Scalars["Boolean"]>;
  partIssueSources?: Maybe<PartIssueSources>;
  vehicle?: Maybe<VehicleType>;
  inspectionReportSentAt?: Maybe<Scalars["Date"]>;
  signedDocument?: Maybe<Scalars["Int"]>;
  inquiryRequest?: Maybe<InquiryRequest>;
  followUpDate?: Maybe<Scalars["Date"]>;
  jobStartedAt?: Maybe<Scalars["Date"]>;
  jobEndedAt?: Maybe<Scalars["Date"]>;
  scopeEscalated?: Maybe<Scalars["Boolean"]>;
  rescheduleSummary?: Maybe<RescheduleSummary>;
  quotedTotal?: Maybe<Scalars["Currency"]>;
  isDealer?: Maybe<Scalars["Boolean"]>;
  isExceptionVehicle?: Maybe<Scalars["Boolean"]>;
  partOrders?: Maybe<Array<Maybe<PartOrder>>>;
  /**
   * Stored services left out of `services` because they are missing a required
   * field (e.g. customerPrice). Non-zero means ops must regenerate the services.
   */
  invalidServicesCount?: Maybe<Scalars["Int"]>;
};

export type JobAndInvoiceResult = {
  __typename?: "JobAndInvoiceResult";
  job?: Maybe<Job>;
  invoice?: Maybe<Invoice>;
};

export type JobConvertExperiments = {
  __typename?: "JobConvertExperiments";
  successPageSocialProof?: Maybe<Scalars["String"]>;
  leadFormSelfBooking?: Maybe<Scalars["String"]>;
};

export type JobFeedback = {
  __typename?: "JobFeedback";
  rating?: Maybe<Scalars["Int"]>;
  doneBetter?: Maybe<Array<Maybe<Scalars["String"]>>>;
  additionalComments?: Maybe<Scalars["String"]>;
};

export type JobFeedbackInput = {
  rating?: Maybe<Scalars["Int"]>;
  doneBetter?: Maybe<Array<Maybe<Scalars["String"]>>>;
  additionalComments?: Maybe<Scalars["String"]>;
};

export enum JobRoutingPriority {
  Low = "LOW",
  Normal = "NORMAL",
  High = "HIGH",
  AbsolutelyCritical = "ABSOLUTELY_CRITICAL",
}

export type JobsConnection = {
  __typename?: "JobsConnection";
  edges: Array<Job>;
  pageInfo?: Maybe<PageInfo>;
};

export type Lead = {
  __typename?: "Lead";
  id?: Maybe<Scalars["ID"]>;
  address?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  source?: Maybe<Scalars["String"]>;
  hearAboutUs?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  vehicleInfo?: Maybe<VehicleInfo>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptom>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  serviceUrgency?: Maybe<Scalars["String"]>;
};

export type LeadInput = {
  address?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  source?: Maybe<Scalars["String"]>;
  hearAboutUs?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  vehicleInfo: VehicleInfoInput;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  additionalData?: Maybe<Scalars["JSON"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  serviceUrgency?: Maybe<Scalars["String"]>;
};

export type Location = {
  __typename?: "Location";
  type?: Maybe<Scalars["String"]>;
  coordinates?: Maybe<Array<Maybe<Scalars["Float"]>>>;
};

export type LocationAddress = {
  __typename?: "LocationAddress";
  addressLine?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  zipCode?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
};

export type LocationAddressInput = {
  addressLine?: Maybe<Scalars["String"]>;
  addressLine2?: Maybe<Scalars["String"]>;
  zipCode?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
};

export type Market = {
  __typename?: "Market";
  id: Scalars["ID"];
  name: Scalars["String"];
  phoneNumber?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  addressStreet?: Maybe<Scalars["String"]>;
  addressCity?: Maybe<Scalars["String"]>;
  addressState?: Maybe<Scalars["String"]>;
  addressZipCode?: Maybe<Scalars["String"]>;
  addressCountry?: Maybe<Scalars["String"]>;
  businessID?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
  activeDays?: Maybe<Array<Scalars["Int"]>>;
  activeServiceArea?: Maybe<Scalars["JSON"]>;
  activeServiceAreaGeoJson?: Maybe<Scalars["JSON"]>;
  marketArea?: Maybe<Scalars["JSON"]>;
  marketAreaGeoJson?: Maybe<Scalars["JSON"]>;
  marketStatus?: Maybe<MarketStatusEnum>;
  visitBalanceCoefficient?: Maybe<Scalars["Float"]>;
  traffic?: Maybe<Scalars["String"]>;
  maxVisitLateness?: Maybe<Scalars["Int"]>;
  maxVehicleOvertime?: Maybe<Scalars["Int"]>;
  padsPricingVariance?: Maybe<MarketPricingVariance>;
  rotorsPricingVariance?: Maybe<MarketPricingVariance>;
  shoesPricingVariance?: Maybe<MarketPricingVariance>;
  drumsPricingVariance?: Maybe<MarketPricingVariance>;
  variance?: Maybe<MarketVariance>;
  salesTaxType?: Maybe<Scalars["String"]>;
  partsTaxRate?: Maybe<Scalars["Float"]>;
  laborTaxRate?: Maybe<Scalars["Float"]>;
  laborRate?: Maybe<Scalars["Currency"]>;
  vendorUnitCostMultipliers?: Maybe<Array<Maybe<VendorUnitCostMultiplier>>>;
};

export type MarketDayCapacity = {
  __typename?: "MarketDayCapacity";
  date: Scalars["String"];
  capacity: Scalars["Int"];
  offAllDay: Scalars["Int"];
  assigned: Scalars["Int"];
  unassigned: Scalars["Int"];
  booked: Scalars["Int"];
  remaining: Scalars["Int"];
};

export type MarketDayVariance = {
  __typename?: "MarketDayVariance";
  monday?: Maybe<Scalars["Currency"]>;
  tuesday?: Maybe<Scalars["Currency"]>;
  wednesday?: Maybe<Scalars["Currency"]>;
  thursday?: Maybe<Scalars["Currency"]>;
  friday?: Maybe<Scalars["Currency"]>;
  saturday?: Maybe<Scalars["Currency"]>;
  sunday?: Maybe<Scalars["Currency"]>;
};

export type MarketDayVarianceInput = {
  monday?: Maybe<Scalars["Currency"]>;
  tuesday?: Maybe<Scalars["Currency"]>;
  wednesday?: Maybe<Scalars["Currency"]>;
  thursday?: Maybe<Scalars["Currency"]>;
  friday?: Maybe<Scalars["Currency"]>;
  saturday?: Maybe<Scalars["Currency"]>;
  sunday?: Maybe<Scalars["Currency"]>;
};

export type MarketLeadTimeVariance = {
  __typename?: "MarketLeadTimeVariance";
  sameDay?: Maybe<Scalars["Currency"]>;
  nextDay?: Maybe<Scalars["Currency"]>;
  oneToTwoDays?: Maybe<Scalars["Currency"]>;
  twoPlusDays?: Maybe<Scalars["Currency"]>;
};

export type MarketLeadTimeVarianceInput = {
  sameDay?: Maybe<Scalars["Currency"]>;
  nextDay?: Maybe<Scalars["Currency"]>;
  oneToTwoDays?: Maybe<Scalars["Currency"]>;
  twoPlusDays?: Maybe<Scalars["Currency"]>;
};

export type MarketPricingVariance = {
  __typename?: "MarketPricingVariance";
  standardOption?: Maybe<Scalars["Currency"]>;
  premiumOption?: Maybe<Scalars["Currency"]>;
  performanceOption?: Maybe<Scalars["Currency"]>;
};

export type MarketPricingVarianceInput = {
  standardOption?: Maybe<Scalars["Currency"]>;
  premiumOption?: Maybe<Scalars["Currency"]>;
  performanceOption?: Maybe<Scalars["Currency"]>;
};

export enum MarketStatusEnum {
  Test = "Test",
  Active = "Active",
  Inactive = "Inactive",
}

export type MarketVariance = {
  __typename?: "MarketVariance";
  pads?: Maybe<MarketPricingVariance>;
  rotors?: Maybe<MarketPricingVariance>;
  shoes?: Maybe<MarketPricingVariance>;
  drums?: Maybe<MarketPricingVariance>;
  daysOfWeek?: Maybe<MarketDayVariance>;
  leadTime?: Maybe<MarketLeadTimeVariance>;
};

export type MarketVarianceInput = {
  pads?: Maybe<MarketPricingVarianceInput>;
  rotors?: Maybe<MarketPricingVarianceInput>;
  shoes?: Maybe<MarketPricingVarianceInput>;
  drums?: Maybe<MarketPricingVarianceInput>;
  daysOfWeek?: Maybe<MarketDayVarianceInput>;
  leadTime?: Maybe<MarketLeadTimeVarianceInput>;
};

export type Mutation = {
  __typename?: "Mutation";
  contactUs?: Maybe<Scalars["String"]>;
  fleetContactUs?: Maybe<Scalars["String"]>;
  createMarket: Market;
  catchAll?: Maybe<Scalars["JSON"]>;
  createTechnician: Technician;
  createSelfScheduleRequest?: Maybe<StatusError>;
  createSelfReschedule?: Maybe<RescheduleResultV2>;
  createViocSelfScheduleRequest?: Maybe<ViocSelfScheduleStatusError>;
  updateSelfScheduledJobVehicleInformation?: Maybe<UpdateSelfScheduledJobVehicleInformationResponse>;
  attachSignedDocument?: Maybe<Job>;
  ensureMyAppointmentToken?: Maybe<Scalars["String"]>;
  createPartsStore: PartsStore;
  updatePartsStore?: Maybe<PartsStore>;
  privateCreateLead?: Maybe<Contact>;
  createEstimate: Estimate;
  createProduct?: Maybe<Product>;
  createFile?: Maybe<Array<Maybe<File>>>;
  deleteFile?: Maybe<Array<Maybe<File>>>;
  createJob?: Maybe<Job>;
  createAirtableJob?: Maybe<Job>;
  createPaymentIntent: PaymentIntent;
  createInvoice?: Maybe<Invoice>;
  ensureInvoiceReviewShortlink?: Maybe<Scalars["String"]>;
  refreshJobTax: RefreshJobTaxResult;
  createPayment: Payment;
  updateInvoice?: Maybe<Invoice>;
  updateContact?: Maybe<Contact>;
  updateEstimate?: Maybe<Estimate>;
  sendEstimateForJob?: Maybe<Job>;
  getTechnicianRoles?: Maybe<Array<Maybe<TechnicianRole>>>;
  updateTechnician?: Maybe<Technician>;
  updateProduct?: Maybe<Product>;
  updateMyLocation: Technician;
  updateJob: Job;
  updateJobPublic: Job;
  generateViocJobServices: GenerateViocJobServicesResult;
  generateLeadFormEstimate: GenerateLeadFormEstimateResult;
  updateMarket: Market;
  updateAppointment: Appointment;
  deleteAppointment: Scalars["ID"];
  selfCancelAppointment: Job;
  deleteInvoice: Scalars["ID"];
  createAppointment?: Maybe<Appointment>;
  createAvailabilitySnapshot?: Maybe<AvailabilitySnapshotRes>;
  performAction: PerformActionResult;
  generatePresignedUrl?: Maybe<Scalars["String"]>;
  generateGenericPresignedUrl?: Maybe<Scalars["String"]>;
  createFeedback?: Maybe<Scalars["String"]>;
  createProductSet?: Maybe<ProductSet>;
  closeZeroDollarInvoice?: Maybe<JobAndInvoiceResult>;
  closeJob: Job;
  updateJobTimestamps: Job;
  logJobPriorityChange: Job;
  updateProductSet?: Maybe<ProductSet>;
  createTechnicianCurrentAppVersion?: Maybe<TechnicianCurrentAppVersion>;
  createCardSetupIntent?: Maybe<Scalars["JSON"]>;
  addContactPaymentMethod?: Maybe<Contact>;
  deleteContactPaymentMethod?: Maybe<Contact>;
  setContactDefaultPaymentMethod?: Maybe<Contact>;
  holdStripeCard?: Maybe<PaymentIntent>;
  cancelPaymentIntent?: Maybe<Payment>;
  capturePaymentIntent?: Maybe<Scalars["JSON"]>;
  createConfirmedPaymentIntent?: Maybe<PaymentIntent>;
  createOpsManager?: Maybe<User>;
  addCreditCardByOneTimeId: Scalars["Boolean"];
  createCardSetupIntentByOneTimeId?: Maybe<Scalars["JSON"]>;
  createOneTimeIdentifierLink: Scalars["String"];
  createReschedule?: Maybe<Reschedule>;
  createRescheduleV2?: Maybe<RescheduleResultV2>;
  createInquiryRequest?: Maybe<InquiryRequest>;
  createInquiryRequestV2?: Maybe<InquiryRequestV2>;
  createViocInspectionInquiryRequest?: Maybe<CreateViocInspectionInquiryRequestResult>;
  createViocLead?: Maybe<ViocLead>;
  updateDiagnostics?: Maybe<Job>;
  updateJobConvertExperimentsByInquiryId?: Maybe<Job>;
  updateInquiryWithConvertExperimentsData?: Maybe<InquiryRequest>;
  sendAddContactCardSms?: Maybe<Scalars["JSON"]>;
  createLeadFromInvoice?: Maybe<Scalars["JSON"]>;
  createPromoCode?: Maybe<PromoCode>;
  updatePromoCode?: Maybe<PromoCode>;
  getAQuote?: Maybe<GetAQuoteResult>;
  opsAdminCreateInquiryRequest?: Maybe<OpsAdminCreateInquiryRequestResult>;
  validatePromoCode?: Maybe<PromoCode>;
  sendReceiptWithoutPaymentCheck?: Maybe<Scalars["JSON"]>;
  createPromoUser?: Maybe<PromoUser>;
  upsertVehicle?: Maybe<VehicleType>;
  getVinFromLicensePlate?: Maybe<Scalars["String"]>;
  uploadServicesToCarfax?: Maybe<Scalars["String"]>;
  customerWebappCreatePaymentIntent?: Maybe<PaymentIntent>;
  requestBuyNowPayLater?: Maybe<Scalars["JSON"]>;
  requestSendCheckoutLink?: Maybe<Scalars["JSON"]>;
  discountTireContactUs?: Maybe<DiscountTireContactUsResult>;
  addOilChange: Job;
  noticeLowMarginJob?: Maybe<Activity>;
  noticeRecentEstimateJob?: Maybe<Activity>;
  noticeUnpaidInvoice?: Maybe<Activity>;
  noticeUnserviceableVehicleJob?: Maybe<Activity>;
  noticeDealershipPartsJob?: Maybe<Activity>;
  noticeInactiveZipDayJob?: Maybe<Activity>;
  createPartOrder: PartOrder;
  updatePartOrder: PartOrder;
  cancelPartOrder: PartOrder;
  uncancelPartOrder: PartOrder;
  createPartOrderItem: PartOrderItemV2;
  updatePartOrderItem: PartOrderItemV2;
  updatePartOrderItemStatus: PartOrderItemV2;
  deletePartOrderItem: PartOrderItemV2;
  createPackageDiscount?: Maybe<PackageDiscountType>;
  updatePackageDiscount?: Maybe<PackageDiscountType>;
  deletePackageDiscount?: Maybe<Scalars["Boolean"]>;
  createGblLocation: GblLocation;
  updateGblLocation?: Maybe<GblLocation>;
  upsertGblLocationByStoreId: GblLocation;
  deleteGblLocation?: Maybe<GblLocation>;
  updateMyAppointmentEmail?: Maybe<UpdateMyAppointmentEmailResponse>;
  /** NUB-450: saves a contact whose EIN changes (requires ops:manage) and re-prices its unpaid invoices and open jobs in the same request. */
  updateContactTaxExemption: ContactTaxExemptionUpdateResult;
  /** NUB-450: applies the contact's current EIN to an editable (unpaid) invoice and saves the recalculated price. */
  recalculateInvoiceTax: Invoice;
};

export type MutationContactUsArgs = {
  contactUsInput: ContactUsInput;
};

export type MutationFleetContactUsArgs = {
  contactUsInput: ContactUsInput;
};

export type MutationCreateMarketArgs = {
  createMarketInput: CreateMarketInput;
};

export type MutationCatchAllArgs = {
  catchAllInput: Scalars["JSON"];
};

export type MutationCreateTechnicianArgs = {
  createTechnicianInput: CreateTechnicianInput;
};

export type MutationCreateSelfScheduleRequestArgs = {
  createSelfScheduleRequest?: Maybe<CreateSelfScheduleRequest>;
};

export type MutationCreateSelfRescheduleArgs = {
  createSelfRescheduleRequest: CreateSelfRescheduleRequest;
};

export type MutationCreateViocSelfScheduleRequestArgs = {
  createViocSelfScheduleRequest?: Maybe<CreateViocSelfScheduleRequest>;
};

export type MutationUpdateSelfScheduledJobVehicleInformationArgs = {
  updateSelfScheduledJobVehicleInformationInput: UpdateSelfScheduledJobVehicleInformationInput;
};

export type MutationAttachSignedDocumentArgs = {
  id: Scalars["ID"];
  signedDocument: Scalars["Int"];
};

export type MutationEnsureMyAppointmentTokenArgs = {
  jobId: Scalars["ID"];
};

export type MutationCreatePartsStoreArgs = {
  partsStoreInput: PartsStoreInput;
};

export type MutationUpdatePartsStoreArgs = {
  id: Scalars["ID"];
  partsStoreInput: PartsStoreInput;
};

export type MutationPrivateCreateLeadArgs = {
  createLeadInput: CreateLeadInput;
};

export type MutationCreateEstimateArgs = {
  createEstimateInput: CreateEstimateInput;
};

export type MutationCreateProductArgs = {
  createProductInput: CreateProductInput;
};

export type MutationCreateFileArgs = {
  createFileInput: CreateFileInput;
};

export type MutationDeleteFileArgs = {
  fileName: Scalars["String"];
  contact: Scalars["ID"];
};

export type MutationCreateJobArgs = {
  createJobInput: CreateJobInput;
};

export type MutationCreateAirtableJobArgs = {
  createAirtableJobInput: CreateAirtableJobInput;
};

export type MutationCreatePaymentIntentArgs = {
  createPaymentInput: CreatePaymentInput;
  idempotencyKey?: Maybe<Scalars["String"]>;
};

export type MutationCreateInvoiceArgs = {
  createInvoiceInput: CreateInvoiceInput;
};

export type MutationEnsureInvoiceReviewShortlinkArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationRefreshJobTaxArgs = {
  jobId: Scalars["ID"];
};

export type MutationCreatePaymentArgs = {
  createPaymentInput: CreatePaymentInput;
};

export type MutationUpdateInvoiceArgs = {
  id: Scalars["ID"];
  updateInvoiceInput: UpdateInvoiceInput;
};

export type MutationUpdateContactArgs = {
  id: Scalars["ID"];
  updateContactInput: UpdateContactInput;
};

export type MutationUpdateEstimateArgs = {
  id: Scalars["ID"];
  updateEstimateInput: UpdateEstimateInput;
};

export type MutationSendEstimateForJobArgs = {
  sendEstimateForJobInput: SendEstimateForJobInput;
};

export type MutationUpdateTechnicianArgs = {
  id: Scalars["ID"];
  updateTechnicianInput: UpdateTechnicianInput;
};

export type MutationUpdateProductArgs = {
  id: Scalars["ID"];
  updateProductInput: UpdateProductInput;
};

export type MutationUpdateMyLocationArgs = {
  updateLocationInput: UpdateLocationInput;
};

export type MutationUpdateJobArgs = {
  id: Scalars["ID"];
  updateJobInput: UpdateJobInput;
};

export type MutationUpdateJobPublicArgs = {
  id: Scalars["ID"];
  updateJobPublicInput: UpdateJobPublicInput;
};

export type MutationGenerateViocJobServicesArgs = {
  jobId: Scalars["ID"];
};

export type MutationGenerateLeadFormEstimateArgs = {
  jobId: Scalars["ID"];
};

export type MutationUpdateMarketArgs = {
  id: Scalars["ID"];
  updateMarketInput: UpdateMarketInput;
};

export type MutationUpdateAppointmentArgs = {
  id: Scalars["ID"];
  updateAppointmentInput: AppointmentInput;
};

export type MutationDeleteAppointmentArgs = {
  id: Scalars["ID"];
};

export type MutationSelfCancelAppointmentArgs = {
  cancelAppointmentInput: CancelAppointmentInput;
};

export type MutationDeleteInvoiceArgs = {
  id: Scalars["ID"];
};

export type MutationCreateAppointmentArgs = {
  createAppointmentInput: AppointmentInput;
};

export type MutationCreateAvailabilitySnapshotArgs = {
  createAvailabilitySnapshotInput: CreateAvailabilitySnapshotInput;
};

export type MutationPerformActionArgs = {
  performActionInput: PerformActionInput;
};

export type MutationGeneratePresignedUrlArgs = {
  customerId: Scalars["ID"];
  fileName: Scalars["String"];
};

export type MutationGenerateGenericPresignedUrlArgs = {
  path: Scalars["String"];
};

export type MutationCreateFeedbackArgs = {
  createFeedbackInput: CreateFeedbackInput;
};

export type MutationCreateProductSetArgs = {
  createProductSetInput: CreateProductSetInput;
};

export type MutationCloseZeroDollarInvoiceArgs = {
  closeZeroDollarInvoiceInput: CloseZeroDollarInvoiceInput;
};

export type MutationCloseJobArgs = {
  jobId: Scalars["ID"];
  endedAt?: Maybe<Scalars["Date"]>;
};

export type MutationUpdateJobTimestampsArgs = {
  jobId: Scalars["ID"];
  jobStartedAt?: Maybe<Scalars["Date"]>;
  jobEndedAt?: Maybe<Scalars["Date"]>;
};

export type MutationLogJobPriorityChangeArgs = {
  jobId: Scalars["ID"];
  updated: JobRoutingPriority;
  previous?: Maybe<JobRoutingPriority>;
};

export type MutationUpdateProductSetArgs = {
  id: Scalars["ID"];
  updateProductSetInput: UpdateProductSetInput;
};

export type MutationCreateTechnicianCurrentAppVersionArgs = {
  version?: Maybe<Scalars["String"]>;
};

export type MutationCreateCardSetupIntentArgs = {
  contactId: Scalars["ID"];
  nameOnCard?: Maybe<Scalars["String"]>;
};

export type MutationAddContactPaymentMethodArgs = {
  contactId: Scalars["ID"];
  paymentMethodId: Scalars["ID"];
};

export type MutationDeleteContactPaymentMethodArgs = {
  contactId: Scalars["ID"];
  paymentMethodId: Scalars["ID"];
};

export type MutationSetContactDefaultPaymentMethodArgs = {
  contactId: Scalars["ID"];
  paymentMethodId: Scalars["ID"];
};

export type MutationHoldStripeCardArgs = {
  createPaymentInputHoldCard: CreatePaymentInputHoldCard;
};

export type MutationCancelPaymentIntentArgs = {
  paymentId: Scalars["ID"];
};

export type MutationCapturePaymentIntentArgs = {
  paymentIntentId: Scalars["ID"];
  invoiceId: Scalars["ID"];
  amount: Scalars["Currency"];
  idempotencyKey?: Maybe<Scalars["String"]>;
};

export type MutationCreateConfirmedPaymentIntentArgs = {
  createPaymentInput: CreatePaymentInput;
  idempotencyKey?: Maybe<Scalars["String"]>;
};

export type MutationCreateOpsManagerArgs = {
  createUserInput: CreateUserInput;
};

export type MutationAddCreditCardByOneTimeIdArgs = {
  identifier: Scalars["String"];
  paymentMethodId: Scalars["ID"];
};

export type MutationCreateCardSetupIntentByOneTimeIdArgs = {
  identifier: Scalars["String"];
};

export type MutationCreateOneTimeIdentifierLinkArgs = {
  contactId: Scalars["ID"];
};

export type MutationCreateRescheduleArgs = {
  rescheduleInput: RescheduleInput;
};

export type MutationCreateRescheduleV2Args = {
  rescheduleInput: RescheduleInputV2;
};

export type MutationCreateInquiryRequestArgs = {
  createInquiryRequestInput: CreateInquiryRequestInput;
};

export type MutationCreateInquiryRequestV2Args = {
  createInquiryRequestInput: CreateInquiryRequestInput;
};

export type MutationCreateViocInspectionInquiryRequestArgs = {
  createViocInspectionInquiryRequestInput: CreateViocInspectionInquiryRequestInput;
};

export type MutationCreateViocLeadArgs = {
  createViocLeadInput: CreateViocLeadInput;
};

export type MutationUpdateDiagnosticsArgs = {
  updateDiagnosticsInput: UpdateDiagnosticsInput;
};

export type MutationUpdateJobConvertExperimentsByInquiryIdArgs = {
  updateJobConvertExperimentsByInquiryIdInput: UpdateJobConvertExperimentsByInquiryIdInput;
};

export type MutationUpdateInquiryWithConvertExperimentsDataArgs = {
  updateInquiryWithConvertExperimentsDataInput: UpdateInquiryWithConvertExperimentsDataInput;
};

export type MutationSendAddContactCardSmsArgs = {
  contactId: Scalars["ID"];
  market?: Maybe<Scalars["String"]>;
};

export type MutationCreateLeadFromInvoiceArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationCreatePromoCodeArgs = {
  createPromoCodeInput: PromoCodeInput;
};

export type MutationUpdatePromoCodeArgs = {
  updatePromoCodeInput: UpdatePromoCodeInput;
};

export type MutationGetAQuoteArgs = {
  getAQuoteInput: GetAQuoteInput;
};

export type MutationOpsAdminCreateInquiryRequestArgs = {
  createInquiryRequestInput: CreateInquiryRequestInput;
};

export type MutationValidatePromoCodeArgs = {
  code: Scalars["String"];
  jobId?: Maybe<Scalars["String"]>;
};

export type MutationSendReceiptWithoutPaymentCheckArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationCreatePromoUserArgs = {
  promoUserInput: PromoUserInput;
};

export type MutationUpsertVehicleArgs = {
  vehicleInputData?: Maybe<VehicleInput>;
};

export type MutationGetVinFromLicensePlateArgs = {
  licensePlate?: Maybe<Scalars["String"]>;
  stateCode?: Maybe<Scalars["String"]>;
};

export type MutationUploadServicesToCarfaxArgs = {
  date?: Maybe<Scalars["String"]>;
};

export type MutationCustomerWebappCreatePaymentIntentArgs = {
  createPaymentIntentInput: CreatePaymentIntentInput;
  idempotencyKey?: Maybe<Scalars["String"]>;
};

export type MutationRequestBuyNowPayLaterArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationRequestSendCheckoutLinkArgs = {
  invoiceId: Scalars["ID"];
};

export type MutationDiscountTireContactUsArgs = {
  discountTireContactUsInput?: Maybe<DiscountTireContactUsInput>;
};

export type MutationAddOilChangeArgs = {
  jobId: Scalars["ID"];
};

export type MutationNoticeLowMarginJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationNoticeRecentEstimateJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationNoticeUnpaidInvoiceArgs = {
  jobId: Scalars["ID"];
};

export type MutationNoticeUnserviceableVehicleJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationNoticeDealershipPartsJobArgs = {
  jobId: Scalars["ID"];
};

export type MutationNoticeInactiveZipDayJobArgs = {
  jobId: Scalars["ID"];
  zip: Scalars["String"];
  date: Scalars["Date"];
};

export type MutationCreatePartOrderArgs = {
  createPartOrderInput: CreatePartOrderInput;
};

export type MutationUpdatePartOrderArgs = {
  id: Scalars["ID"];
  updatePartOrderInput: UpdatePartOrderInput;
};

export type MutationCancelPartOrderArgs = {
  id: Scalars["ID"];
  cancelationDetails: CancelationDetailsInput;
};

export type MutationUncancelPartOrderArgs = {
  id: Scalars["ID"];
};

export type MutationCreatePartOrderItemArgs = {
  createPartOrderItemInput: CreatePartOrderItemInput;
};

export type MutationUpdatePartOrderItemArgs = {
  id: Scalars["ID"];
  updatePartOrderItemInput: UpdatePartOrderItemInput;
};

export type MutationUpdatePartOrderItemStatusArgs = {
  id: Scalars["ID"];
  status: PartOrderItemStatus;
};

export type MutationDeletePartOrderItemArgs = {
  id: Scalars["ID"];
};

export type MutationCreatePackageDiscountArgs = {
  packageDiscountInput: PackageDiscountInput;
};

export type MutationUpdatePackageDiscountArgs = {
  id: Scalars["ID"];
  packageDiscountInput: PackageDiscountInput;
};

export type MutationDeletePackageDiscountArgs = {
  id: Scalars["ID"];
};

export type MutationCreateGblLocationArgs = {
  createGblLocationInput: CreateGblLocationInput;
};

export type MutationUpdateGblLocationArgs = {
  id: Scalars["ID"];
  updateGblLocationInput: UpdateGblLocationInput;
};

export type MutationUpsertGblLocationByStoreIdArgs = {
  createGblLocationInput: CreateGblLocationInput;
};

export type MutationDeleteGblLocationArgs = {
  id: Scalars["ID"];
};

export type MutationUpdateMyAppointmentEmailArgs = {
  updateMyAppointmentEmailInput: UpdateMyAppointmentEmailInput;
};

export type MutationUpdateContactTaxExemptionArgs = {
  id: Scalars["ID"];
  updateContactInput: UpdateContactInput;
};

export type MutationRecalculateInvoiceTaxArgs = {
  invoiceId: Scalars["ID"];
};

export type Named = {
  __typename?: "Named";
  name?: Maybe<Scalars["String"]>;
};

export type OdometerHistoryInput = {
  mileage?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  updatedBy?: Maybe<Scalars["String"]>;
  include?: Maybe<Scalars["Boolean"]>;
};

export type OdometerHistoryType = {
  __typename?: "OdometerHistoryType";
  mileage?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  updatedBy?: Maybe<Scalars["String"]>;
  include?: Maybe<Scalars["Boolean"]>;
};

export type OilChangeDate = {
  __typename?: "OilChangeDate";
  date?: Maybe<Scalars["Date"]>;
  unavailable?: Maybe<Scalars["Boolean"]>;
};

export type OilChangeDateInput = {
  date?: Maybe<Scalars["Date"]>;
  unavailable?: Maybe<Scalars["Boolean"]>;
};

export type OilChangeMileage = {
  __typename?: "OilChangeMileage";
  mileage?: Maybe<Scalars["String"]>;
  unavailable?: Maybe<Scalars["Boolean"]>;
};

export type OilChangeMileageInput = {
  mileage?: Maybe<Scalars["String"]>;
  unavailable?: Maybe<Scalars["Boolean"]>;
};

export type OilLifeListItem = {
  __typename?: "OilLifeListItem";
  estimatedNextOilChangeTimeline?: Maybe<Scalars["String"]>;
  nextOilChangeMileage?: Maybe<OilChangeMileage>;
  nextOilChangeDate?: Maybe<OilChangeDate>;
  lastOilChangeDate?: Maybe<OilChangeDate>;
};

export type OilLifeListItemInput = {
  estimatedNextOilChangeTimeline?: Maybe<Scalars["String"]>;
  nextOilChangeMileage?: Maybe<OilChangeMileageInput>;
  nextOilChangeDate?: Maybe<OilChangeDateInput>;
  lastOilChangeDate?: Maybe<OilChangeDateInput>;
};

export type OneTimeIdentifierValidStatus = {
  __typename?: "OneTimeIdentifierValidStatus";
  status?: Maybe<Scalars["Boolean"]>;
  message?: Maybe<Scalars["String"]>;
};

export type OpsAdminCreateInquiryRequestResult = {
  __typename?: "OpsAdminCreateInquiryRequestResult";
  inquiryRequest?: Maybe<InquiryRequest>;
  contact?: Maybe<Contact>;
  serviceRequest?: Maybe<Job>;
};

export type OptimizerRun = {
  __typename?: "OptimizerRun";
  id: Scalars["ID"];
  market: Scalars["String"];
  date: Scalars["String"];
  runTimestamp: Scalars["Date"];
  status: Scalars["String"];
  jobsCount: Scalars["Int"];
  unservedCount: Scalars["Int"];
  unservedJobIds: Array<Scalars["String"]>;
  unservedJobNumbers: Array<Scalars["String"]>;
  unservedJobs?: Maybe<Array<Maybe<Job>>>;
  source: Scalars["String"];
};

export type PackageDiscountInput = {
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  rules: Array<RuleInput>;
  stackable?: Maybe<Scalars["Boolean"]>;
  valid_from?: Maybe<Scalars["Date"]>;
  valid_to?: Maybe<Scalars["Date"]>;
  active: Scalars["Boolean"];
};

export type PackageDiscountType = {
  __typename?: "PackageDiscountType";
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  rules: Array<RuleType>;
  stackable?: Maybe<Scalars["Boolean"]>;
  valid_from?: Maybe<Scalars["Date"]>;
  valid_to?: Maybe<Scalars["Date"]>;
  active: Scalars["Boolean"];
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
};

export type PadThickness = {
  __typename?: "PadThickness";
  thickness?: Maybe<Scalars["String"]>;
  unavailable?: Maybe<Scalars["Boolean"]>;
};

export type PadThicknessInput = {
  thickness?: Maybe<Scalars["String"]>;
  unavailable?: Maybe<Scalars["Boolean"]>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  prevCursor?: Maybe<Scalars["String"]>;
  hasNextPage: Scalars["Boolean"];
  endCursor?: Maybe<Scalars["String"]>;
  numRecords?: Maybe<Scalars["Int"]>;
  offset?: Maybe<Scalars["Int"]>;
};

export type PaginatedQueryInput = {
  filter?: Maybe<Scalars["JSON"]>;
  skip: Scalars["Int"];
  limit: Scalars["Int"];
  sort?: Maybe<Scalars["JSON"]>;
};

export type Part = {
  __typename?: "Part";
  id: Scalars["ID"];
  partId: Scalars["Int"];
  productName: Scalars["String"];
  label: Scalars["String"];
  vendorUnitCost: Scalars["Currency"];
  expectedVendorUnitCost?: Maybe<Scalars["Currency"]>;
  type: Scalars["String"];
};

export type PartIssueSources = {
  __typename?: "PartIssueSources";
  onJobOrderingIssue: Scalars["Boolean"];
  hqSurvey: Scalars["Boolean"];
  partOrder: Scalars["Boolean"];
  postJobChecklist: Scalars["Boolean"];
};

export type PartOrder = {
  __typename?: "PartOrder";
  id: Scalars["ID"];
  job?: Maybe<Job>;
  orderNumber?: Maybe<Scalars["String"]>;
  store?: Maybe<PartsStore>;
  partsLocation?: Maybe<Scalars["String"]>;
  status?: Maybe<PartOrderStatus>;
  timestamp?: Maybe<Scalars["Date"]>;
  createdBy?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  orderTotalCost?: Maybe<Scalars["Float"]>;
  orderMethod?: Maybe<Scalars["String"]>;
  partOrderingIssue?: Maybe<Scalars["String"]>;
  partOrderingIssueNotes?: Maybe<Scalars["String"]>;
  cancelationDetails?: Maybe<CancelationDetails>;
  items?: Maybe<Array<Maybe<PartOrderItemV2>>>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  partOrderingIssueAt?: Maybe<Scalars["Date"]>;
  partOrderingIssueBy?: Maybe<Scalars["String"]>;
};

export type PartOrderItem = {
  __typename?: "PartOrderItem";
  partsStore?: Maybe<PartsStore>;
  isOrdered?: Maybe<Scalars["Boolean"]>;
  partNumber?: Maybe<Scalars["String"]>;
};

export type PartOrderItemInput = {
  partsStore?: Maybe<Scalars["ID"]>;
  isOrdered?: Maybe<Scalars["Boolean"]>;
  partNumber?: Maybe<Scalars["String"]>;
};

export enum PartOrderItemStatus {
  Ordered = "Ordered",
  Collected = "Collected",
  PickedUp = "Picked_Up",
  OnVan = "On_Van",
  Returned = "Returned",
}

export type PartOrderItemV2 = {
  __typename?: "PartOrderItemV2";
  id: Scalars["ID"];
  partOrder?: Maybe<PartOrder>;
  units?: Maybe<Scalars["Float"]>;
  vendorUnitCost?: Maybe<Scalars["Float"]>;
  partNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PartOrderItemStatus>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  pickedUpAt?: Maybe<Scalars["Date"]>;
  pickedUpBy?: Maybe<Scalars["String"]>;
};

export type PartOrderItemsConnection = {
  __typename?: "PartOrderItemsConnection";
  data: Array<PartOrderItemV2>;
  total: Scalars["Int"];
};

export enum PartOrderStatus {
  Ordered = "Ordered",
  Canceled = "Canceled",
}

export type PartOrdersConnection = {
  __typename?: "PartOrdersConnection";
  data: Array<PartOrder>;
  total: Scalars["Int"];
};

export type PartsCalcs = {
  __typename?: "PartsCalcs";
  marketVendorUnitCostMultiplierUsed?: Maybe<Scalars["Float"]>;
  overriddenCustomerPrice?: Maybe<Scalars["Boolean"]>;
  vendorCost?: Maybe<Scalars["Currency"]>;
  totalPrice?: Maybe<Scalars["Currency"]>;
};

export type PartsCalcsInput = {
  marketVendorUnitCostMultiplierUsed?: Maybe<Scalars["Float"]>;
  overriddenCustomerPrice?: Maybe<Scalars["Boolean"]>;
  vendorCost?: Maybe<Scalars["Currency"]>;
  totalPrice?: Maybe<Scalars["Currency"]>;
};

export type PartsInfo = {
  __typename?: "PartsInfo";
  partsOrderNumber?: Maybe<Scalars["String"]>;
  partsLocation?: Maybe<Scalars["String"]>;
  partsOrdered?: Maybe<Scalars["Boolean"]>;
  cancellationInitiated?: Maybe<Scalars["Boolean"]>;
  cancellationTimestamp?: Maybe<Scalars["Date"]>;
  partsOrderedTimestamp?: Maybe<Scalars["Date"]>;
  partsNotes?: Maybe<Scalars["String"]>;
  reasonRescheduled?: Maybe<Scalars["String"]>;
  partsOrderingIssue?: Maybe<Scalars["String"]>;
  callForPartsTicketNumber?: Maybe<Scalars["String"]>;
};

export type PartsInfoInput = {
  partsOrderNumber?: Maybe<Scalars["String"]>;
  partsLocation?: Maybe<Scalars["String"]>;
  partsOrdered?: Maybe<Scalars["Boolean"]>;
  cancellationInitiated?: Maybe<Scalars["Boolean"]>;
  cancellationTimestamp?: Maybe<Scalars["Date"]>;
  partsOrderedTimestamp?: Maybe<Scalars["Date"]>;
  partsNotes?: Maybe<Scalars["String"]>;
  partsOrderingIssue?: Maybe<Scalars["String"]>;
  callForPartsTicketNumber?: Maybe<Scalars["String"]>;
};

export type PartsOrderingIssuesSurvey = {
  __typename?: "PartsOrderingIssuesSurvey";
  partsCorrect?: Maybe<Scalars["Boolean"]>;
  partsStores?: Maybe<Array<Maybe<Scalars["String"]>>>;
  partsIssues?: Maybe<Array<Maybe<Scalars["String"]>>>;
  additionalDetails?: Maybe<Scalars["String"]>;
  completed?: Maybe<Scalars["Boolean"]>;
  submittedBy?: Maybe<Scalars["String"]>;
};

export type PartsOrderingIssuesSurveyInput = {
  partsCorrect?: Maybe<Scalars["Boolean"]>;
  partsStores?: Maybe<Array<Maybe<Scalars["String"]>>>;
  partsIssues?: Maybe<Array<Maybe<Scalars["String"]>>>;
  additionalDetails?: Maybe<Scalars["String"]>;
  completed?: Maybe<Scalars["Boolean"]>;
  submittedBy?: Maybe<Scalars["String"]>;
};

export type PartsStore = {
  __typename?: "PartsStore";
  id: Scalars["ID"];
  storeNumber: Scalars["String"];
  name: Scalars["String"];
  address?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zipcode?: Maybe<Scalars["String"]>;
  vendor?: Maybe<Scalars["String"]>;
  market?: Maybe<Market>;
  deactivated?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  distanceFromReference?: Maybe<Scalars["Float"]>;
};

export type PartsStoreInput = {
  storeNumber: Scalars["String"];
  name: Scalars["String"];
  address?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zipcode?: Maybe<Scalars["String"]>;
  vendor?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["ID"]>;
  deactivated?: Maybe<Scalars["Boolean"]>;
};

export type Payment = {
  __typename?: "Payment";
  id: Scalars["ID"];
  paymentNumber?: Maybe<Scalars["String"]>;
  paymentIntentId?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  source?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  receivedDate?: Maybe<Scalars["Date"]>;
  payer?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Currency"]>;
  partsCost?: Maybe<Scalars["Currency"]>;
  laborCost?: Maybe<Scalars["Currency"]>;
  subTotal?: Maybe<Scalars["Currency"]>;
  partsTax?: Maybe<Scalars["Currency"]>;
  laborTax?: Maybe<Scalars["Currency"]>;
  totalTax?: Maybe<Scalars["Currency"]>;
  invoicePrice?: Maybe<Scalars["Currency"]>;
  paymentMethod?: Maybe<Scalars["String"]>;
  tip?: Maybe<Scalars["Currency"]>;
  invoice?: Maybe<Invoice>;
  job?: Maybe<Job>;
  contact?: Maybe<Contact>;
  createdBy?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
};

export type PaymentConnection = {
  __typename?: "PaymentConnection";
  edges?: Maybe<Array<Maybe<Payment>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PaymentIntent = {
  __typename?: "PaymentIntent";
  amount_capturable?: Maybe<Scalars["Int"]>;
  amount_received?: Maybe<Scalars["Int"]>;
  amount?: Maybe<Scalars["Int"]>;
  application_fee_amount?: Maybe<Scalars["Int"]>;
  canceled_at?: Maybe<Scalars["Int"]>;
  cancellation_reason?: Maybe<Scalars["JSON"]>;
  capture_method?: Maybe<Scalars["JSON"]>;
  charges?: Maybe<Scalars["JSON"]>;
  client_secret?: Maybe<Scalars["String"]>;
  confirmation_method?: Maybe<Scalars["JSON"]>;
  created?: Maybe<Scalars["Int"]>;
  currency?: Maybe<Scalars["String"]>;
  customer?: Maybe<Scalars["JSON"]>;
  description?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  invoice?: Maybe<Scalars["JSON"]>;
  invoicePrice?: Maybe<Scalars["Int"]>;
  job?: Maybe<Scalars["JSON"]>;
  last_payment_error?: Maybe<Scalars["JSON"]>;
  livemode?: Maybe<Scalars["Boolean"]>;
  metadata?: Maybe<Scalars["JSON"]>;
  next_action?: Maybe<Scalars["JSON"]>;
  object?: Maybe<Scalars["JSON"]>;
  on_behalf_of?: Maybe<Scalars["JSON"]>;
  payment_method_options?: Maybe<Scalars["JSON"]>;
  payment_method_types?: Maybe<Array<Maybe<Scalars["String"]>>>;
  payment_method?: Maybe<Scalars["JSON"]>;
  receipt_email?: Maybe<Scalars["String"]>;
  review?: Maybe<Scalars["JSON"]>;
  setup_future_usage?: Maybe<Scalars["JSON"]>;
  shipping?: Maybe<Scalars["JSON"]>;
  source?: Maybe<Scalars["String"]>;
  statement_descriptor_suffix?: Maybe<Scalars["String"]>;
  statement_descriptor?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["JSON"]>;
  transfer_data?: Maybe<Scalars["JSON"]>;
  transfer_group?: Maybe<Scalars["String"]>;
};

export type PerformActionInput = {
  actionName: Scalars["String"];
  entityName: Scalars["String"];
  entityId: Scalars["String"];
};

export type PerformActionResult = Contact | Estimate | Job | Invoice;

export type PossibleEjiItem = {
  __typename?: "PossibleEJIItem";
  serviceProductId: Scalars["ID"];
  productSelection?: Maybe<PossibleProductSelection>;
  type: Scalars["String"];
  units?: Maybe<Scalars["Float"]>;
  overriddenCustomerPrice: Scalars["Boolean"];
  customerPrice?: Maybe<Scalars["Currency"]>;
  vendorUnitCost?: Maybe<Scalars["Currency"]>;
  expectedVendorUnitCost?: Maybe<Scalars["Currency"]>;
  behavior: Scalars["String"];
  category: Scalars["String"];
  notes?: Maybe<Scalars["String"]>;
  orderItem?: Maybe<PossiblePartOrderItem>;
  marketVendorUnitCostMultiplierUsed?: Maybe<Scalars["Float"]>;
  marketLaborRateUsed?: Maybe<Scalars["Currency"]>;
  jobItem?: Maybe<Scalars["ID"]>;
};

export type PossibleEjiItemInput = {
  _id?: Maybe<Scalars["ID"]>;
  serviceProductId: Scalars["ID"];
  productSelection?: Maybe<ProductSelectionInput>;
  type: Scalars["String"];
  units?: Maybe<Scalars["Float"]>;
  overriddenCustomerPrice: Scalars["Boolean"];
  customerPrice?: Maybe<Scalars["Currency"]>;
  vendorUnitCost?: Maybe<Scalars["Currency"]>;
  expectedVendorUnitCost?: Maybe<Scalars["Currency"]>;
  behavior: Scalars["String"];
  category: Scalars["String"];
  notes?: Maybe<Scalars["String"]>;
  orderItem?: Maybe<PartOrderItemInput>;
  partItem?: Maybe<Scalars["ID"]>;
  marketVendorUnitCostMultiplierUsed?: Maybe<Scalars["Float"]>;
  marketLaborRateUsed?: Maybe<Scalars["Currency"]>;
  jobItem?: Maybe<Scalars["ID"]>;
};

export type PossibleEjiPriceResult = {
  __typename?: "PossibleEJIPriceResult";
  ejiPriceInfo: EjiPriceInfo;
  ejiServices: Array<Maybe<PossibleEjiService>>;
};

export type PossibleEjiService = {
  __typename?: "PossibleEJIService";
  service: Scalars["ID"];
  name: Scalars["String"];
  inEstimate: Scalars["Boolean"];
  customerPrice?: Maybe<Scalars["Currency"]>;
  technicianPay?: Maybe<Scalars["Currency"]>;
  items?: Maybe<Array<Maybe<PossibleEjiItem>>>;
  partsCalcs?: Maybe<PartsCalcs>;
  approvalStatus?: Maybe<Scalars["String"]>;
};

export type PossibleEjiServiceInput = {
  service: Scalars["ID"];
  name: Scalars["String"];
  inEstimate: Scalars["Boolean"];
  technicianPay: Scalars["Currency"];
  items: Array<Maybe<PossibleEjiItemInput>>;
  partsCalcs?: Maybe<PartsCalcsInput>;
  approvalStatus?: Maybe<Scalars["String"]>;
};

export type PossiblePartOrderItem = {
  __typename?: "PossiblePartOrderItem";
  partsStore?: Maybe<PartsStore>;
  isOrdered?: Maybe<Scalars["Boolean"]>;
  partNumber?: Maybe<Scalars["String"]>;
};

export type PossibleProductSelection = {
  __typename?: "PossibleProductSelection";
  name?: Maybe<Scalars["String"]>;
  part?: Maybe<Part>;
};

export type PostJobChecklist = {
  __typename?: "PostJobChecklist";
  finalRecomendation?: Maybe<Scalars["String"]>;
  recommendedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  notes?: Maybe<Scalars["String"]>;
  additionalDetails?: Maybe<Scalars["String"]>;
  estimatedTimeline?: Maybe<Scalars["Date"]>;
  needOutstandingRepair?: Maybe<Scalars["Boolean"]>;
  wheelStuds?: Maybe<Scalars["String"]>;
  lugnuts?: Maybe<Scalars["String"]>;
  dashboardLights?: Maybe<Scalars["String"]>;
  testDriveExpirience?: Maybe<Scalars["String"]>;
  otherConcerns?: Maybe<Scalars["String"]>;
  customerNotes?: Maybe<Scalars["String"]>;
  usedOriginalParts?: Maybe<Scalars["Boolean"]>;
  usedOriginalPartsNotes?: Maybe<Scalars["String"]>;
};

export type PostJobChecklistInput = {
  finalRecomendation?: Maybe<Scalars["String"]>;
  recommendedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  notes?: Maybe<Scalars["String"]>;
  additionalDetails?: Maybe<Scalars["String"]>;
  estimatedTimeline?: Maybe<Scalars["Date"]>;
  needOutstandingRepair?: Maybe<Scalars["Boolean"]>;
  wheelStuds?: Maybe<Scalars["String"]>;
  lugnuts?: Maybe<Scalars["String"]>;
  dashboardLights?: Maybe<Scalars["String"]>;
  testDriveExpirience?: Maybe<Scalars["String"]>;
  otherConcerns?: Maybe<Scalars["String"]>;
  customerNotes?: Maybe<Scalars["String"]>;
  usedOriginalParts?: Maybe<Scalars["Boolean"]>;
  usedOriginalPartsNotes?: Maybe<Scalars["String"]>;
};

export type PreJobCheckList = {
  __typename?: "PreJobCheckList";
  frontPads?: Maybe<PreJobCheckListItems>;
  frontPadsV2?: Maybe<BrakePadsListItem>;
  frontRotors?: Maybe<PreJobCheckListItems>;
  rearPads?: Maybe<PreJobCheckListItems>;
  rearPadsV2?: Maybe<BrakePadsListItem>;
  rearRotors?: Maybe<PreJobCheckListItems>;
  brakeFluid?: Maybe<PreJobCheckListItems>;
  brakeShoes?: Maybe<PreJobCheckListItems>;
  brakeDrums?: Maybe<PreJobCheckListItems>;
  calipers?: Maybe<PreJobCheckListItems>;
  shocksStruts?: Maybe<PreJobCheckListItems>;
  controlArms?: Maybe<PreJobCheckListItems>;
  wheelHubs?: Maybe<PreJobCheckListItems>;
  sparkPlugs?: Maybe<PreJobCheckListItems>;
  carBattery?: Maybe<PreJobCheckListItems>;
  alternator?: Maybe<PreJobCheckListItems>;
  engineAirFilter?: Maybe<PreJobCheckListItems>;
  cabinAirFilter?: Maybe<PreJobCheckListItems>;
  driveBelt?: Maybe<PreJobCheckListItems>;
  wiperFluid?: Maybe<PreJobCheckListItems>;
  wiperBlades?: Maybe<PreJobCheckListItems>;
  headLights?: Maybe<PreJobCheckListItems>;
  tailLights?: Maybe<PreJobCheckListItems>;
  lugnuts?: Maybe<PreJobCheckListItems>;
  studs?: Maybe<PreJobCheckListItems>;
  otherBrakeParts?: Maybe<PreJobCheckListItems>;
  dashboardLights?: Maybe<PreJobCheckListItems>;
  odometerReading?: Maybe<PreJobCheckListItems>;
  oilLife?: Maybe<OilLifeListItem>;
  tireTread?: Maybe<TireTreadListItem>;
};

export type PreJobCheckListInput = {
  frontPads?: Maybe<PreJobCheckListItemsInput>;
  frontPadsV2?: Maybe<BrakePadsListItemInput>;
  frontRotors?: Maybe<PreJobCheckListItemsInput>;
  rearPads?: Maybe<PreJobCheckListItemsInput>;
  rearPadsV2?: Maybe<BrakePadsListItemInput>;
  rearRotors?: Maybe<PreJobCheckListItemsInput>;
  brakeFluid?: Maybe<PreJobCheckListItemsInput>;
  brakeShoes?: Maybe<PreJobCheckListItemsInput>;
  brakeDrums?: Maybe<PreJobCheckListItemsInput>;
  calipers?: Maybe<PreJobCheckListItemsInput>;
  shocksStruts?: Maybe<PreJobCheckListItemsInput>;
  controlArms?: Maybe<PreJobCheckListItemsInput>;
  wheelHubs?: Maybe<PreJobCheckListItemsInput>;
  sparkPlugs?: Maybe<PreJobCheckListItemsInput>;
  carBattery?: Maybe<PreJobCheckListItemsInput>;
  alternator?: Maybe<PreJobCheckListItemsInput>;
  engineAirFilter?: Maybe<PreJobCheckListItemsInput>;
  cabinAirFilter?: Maybe<PreJobCheckListItemsInput>;
  driveBelt?: Maybe<PreJobCheckListItemsInput>;
  wiperFluid?: Maybe<PreJobCheckListItemsInput>;
  wiperBlades?: Maybe<PreJobCheckListItemsInput>;
  headLights?: Maybe<PreJobCheckListItemsInput>;
  tailLights?: Maybe<PreJobCheckListItemsInput>;
  lugnuts?: Maybe<PreJobCheckListItemsInput>;
  studs?: Maybe<PreJobCheckListItemsInput>;
  otherBrakeParts?: Maybe<PreJobCheckListItemsInput>;
  dashboardLights?: Maybe<PreJobCheckListItemsInput>;
  odometerReading?: Maybe<PreJobCheckListItemsInput>;
  oilLife?: Maybe<OilLifeListItemInput>;
  tireTread?: Maybe<TireTreadListItemInput>;
};

export type PreJobCheckListItems = {
  __typename?: "PreJobCheckListItems";
  partCondition?: Maybe<Scalars["String"]>;
  additionalInfo?: Maybe<Scalars["String"]>;
};

export type PreJobCheckListItemsInput = {
  partCondition?: Maybe<Scalars["String"]>;
  additionalInfo?: Maybe<Scalars["String"]>;
};

export type PreJobCheckListV2 = {
  __typename?: "PreJobCheckListV2";
  odometer?: Maybe<Scalars["String"]>;
  brakeFluid?: Maybe<CheckListV2BrakeFluidInfo>;
  frontPads?: Maybe<CheckListV2PadsInfo>;
  frontRotors?: Maybe<CheckListV2RotorsInfo>;
  rearPads?: Maybe<CheckListV2PadsInfo>;
  rearRotors?: Maybe<CheckListV2RotorsInfo>;
  usesRearShoesAndDrums?: Maybe<Scalars["Boolean"]>;
  rearShoes?: Maybe<CheckListV2ShoesInfo>;
  rearDrums?: Maybe<CheckListV2DrumsInfo>;
  preExistingConcernsNotes?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  inspectedServices?: Maybe<CheckListV2InspectedServices>;
  withoutCCA?: Maybe<Scalars["Boolean"]>;
  coldCrankingAmps?: Maybe<Scalars["String"]>;
  batteryHealth?: Maybe<Scalars["String"]>;
  withoutBatteryHealth?: Maybe<Scalars["Boolean"]>;
  tireTreadDepth?: Maybe<CheckListV2TireTreadDepth>;
};

export type PreJobCheckListV2Input = {
  odometer?: Maybe<Scalars["String"]>;
  brakeFluid?: Maybe<CheckListV2BrakeFluidInfoInput>;
  frontPads?: Maybe<CheckListV2PadsInfoInput>;
  frontRotors?: Maybe<CheckListV2RotorsInfoInput>;
  rearPads?: Maybe<CheckListV2PadsInfoInput>;
  rearRotors?: Maybe<CheckListV2RotorsInfoInput>;
  usesRearShoesAndDrums?: Maybe<Scalars["Boolean"]>;
  rearShoes?: Maybe<CheckListV2ShoesInfoInput>;
  rearDrums?: Maybe<CheckListV2DrumsInfoInput>;
  preExistingConcernsNotes?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  inspectedServices?: Maybe<CheckListV2InspectedServicesInput>;
  licensePlateState?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  withoutCCA?: Maybe<Scalars["Boolean"]>;
  coldCrankingAmps?: Maybe<Scalars["String"]>;
  batteryHealth?: Maybe<Scalars["String"]>;
  withoutBatteryHealth?: Maybe<Scalars["Boolean"]>;
  tireTreadDepth?: Maybe<CheckListV2TireTreadDepthInput>;
};

export type Product = {
  __typename?: "Product";
  id: Scalars["ID"];
  name: Scalars["String"];
  laborCost: Scalars["Currency"];
  partsCost: Scalars["Currency"];
  amount: Scalars["Currency"];
  description?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type ProductInput = {
  name: Scalars["String"];
  laborCost: Scalars["Currency"];
  partsCost: Scalars["Currency"];
  amount: Scalars["Currency"];
  description?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type ProductSelection = {
  __typename?: "ProductSelection";
  name?: Maybe<Scalars["String"]>;
  part?: Maybe<Part>;
};

export type ProductSelectionInput = {
  name?: Maybe<Scalars["String"]>;
  part?: Maybe<Scalars["ID"]>;
};

export type ProductSet = {
  __typename?: "ProductSet";
  id: Scalars["ID"];
  name: Scalars["String"];
  products?: Maybe<Array<Maybe<Product>>>;
  description?: Maybe<Scalars["String"]>;
};

export type PromoCode = {
  __typename?: "PromoCode";
  id?: Maybe<Scalars["ID"]>;
  code: Scalars["String"];
  name: Scalars["String"];
  createdBy?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  coupon: Coupon;
  startDate?: Maybe<Scalars["Date"]>;
  expiry?: Maybe<Scalars["Date"]>;
  restrictions?: Maybe<Restriction>;
  totalRedemptions?: Maybe<Scalars["Int"]>;
  combinable?: Maybe<Scalars["Boolean"]>;
};

export type PromoCodeInput = {
  code: Scalars["String"];
  name: Scalars["String"];
  status?: Maybe<Scalars["String"]>;
  coupon: CouponInput;
  expiry?: Maybe<Scalars["Date"]>;
  restrictions?: Maybe<RestrictionInput>;
  totalRedemptions?: Maybe<Scalars["Int"]>;
  combinable?: Maybe<Scalars["Boolean"]>;
  startDate?: Maybe<Scalars["Date"]>;
};

export type PromoUser = {
  __typename?: "PromoUser";
  phoneNumber: Scalars["String"];
  promoContent: Scalars["String"];
  queryParams?: Maybe<Scalars["JSON"]>;
};

export type PromoUserInput = {
  phoneNumber: Scalars["String"];
  promoContent: Scalars["String"];
  queryParams?: Maybe<Scalars["JSON"]>;
};

export type Query = {
  __typename?: "Query";
  getAppointmentSuggestions?: Maybe<AppointmentSuggestionsResult>;
  getUniqueAppointmentSuggestions?: Maybe<AppointmentSuggestionsResult>;
  getMarkets?: Maybe<Array<Maybe<Scalars["String"]>>>;
  getMarketsV2?: Maybe<Array<Maybe<Market>>>;
  getMarket?: Maybe<Market>;
  getMarketForAddress?: Maybe<Market>;
  checkViocServiceability: Scalars["Boolean"];
  getMarketForZipcode?: Maybe<Market>;
  getMakes?: Maybe<Array<Maybe<Scalars["String"]>>>;
  getModels?: Maybe<Array<Maybe<Scalars["String"]>>>;
  getSubModels?: Maybe<Array<Maybe<Scalars["String"]>>>;
  getVehicleServiceException?: Maybe<VehicleServiceException>;
  getServiceCatalogueItem?: Maybe<ServiceCatalogueItem>;
  getPartsStores?: Maybe<Array<Maybe<PartsStore>>>;
  getTechniciansHomePartsStores?: Maybe<Array<Maybe<PartsStore>>>;
  getPartsStore?: Maybe<PartsStore>;
  getMyAppointments?: Maybe<Array<Maybe<Appointment>>>;
  getHelloWorld?: Maybe<Scalars["String"]>;
  getAppointments?: Maybe<Array<Maybe<Appointment>>>;
  getAppointmentConflicts?: Maybe<Array<Maybe<Appointment>>>;
  getAppointment?: Maybe<Appointment>;
  getAppointmentCountByRange: Scalars["Int"];
  getContacts: ContactConnection;
  getContactsPaginated: ContactConnection;
  getContactCountByRange: Scalars["Int"];
  getDriveTime?: Maybe<Array<Maybe<DistanceData>>>;
  getEstimates: EstimatesConnection;
  getInvoicesPaginated: InvoiceConnection;
  getEstimatesPaginated: EstimatesConnection;
  getInvoices: InvoiceConnection;
  getVehicleMileage?: Maybe<VehicleMileageDetails>;
  getVehicle: VehicleType;
  getVehicles?: Maybe<Array<Maybe<VehicleType>>>;
  getInvoiceSalesByRange: Scalars["Currency"];
  getJobs: JobsConnection;
  getJobsPaginated: JobsConnection;
  getJobsPaginatedV2: JobsConnection;
  getJobCountByRange: Scalars["Int"];
  getJobsClosedInWindow?: Maybe<Array<Maybe<Job>>>;
  getRoLog?: Maybe<Array<Maybe<OptimizerRun>>>;
  getDispatchInDay?: Maybe<Array<Maybe<Appointment>>>;
  getDispatchDayPrep: Array<DispatchDayPrep>;
  getPayments: PaymentConnection;
  getPaymentsPaginated: PaymentConnection;
  getProducts: Array<Product>;
  getTechnicians: Array<Technician>;
  technicianGetMe: Technician;
  getTechnician: Technician;
  getEstimate: Estimate;
  getPayment: Payment;
  getContact: Contact;
  getContactExists: Scalars["Boolean"];
  getFiles?: Maybe<Array<Maybe<File>>>;
  getJob: Job;
  getJobPublic: Job;
  getJobByToken?: Maybe<Job>;
  getDocumentToSign: DocumentToSign;
  getAvailability?: Maybe<GetAvailabilityRes>;
  getViocAvailability?: Maybe<GetViocAvailabilityRes>;
  customerGetInvoice?: Maybe<CustomerGetInvoiceResult>;
  getInvoice: Invoice;
  getInvoicePublic: Invoice;
  getProduct: Product;
  getTechnicianRoles?: Maybe<Array<TechnicianRole>>;
  getActions: Array<Maybe<Action>>;
  search: SearchResult;
  searchContacts: Array<Maybe<Contact>>;
  searchTechnicians: Array<Maybe<Technician>>;
  searchProducts: Array<Maybe<Product>>;
  getProductSets: Array<ProductSet>;
  getProductSet: ProductSet;
  getReviewsMetaData?: Maybe<ReviewMetaData>;
  getReviews: ReviewConnection;
  getTechnicianCurrentAppVersion?: Maybe<AppVersion>;
  oneTimeIdValid: OneTimeIdentifierValidStatus;
  getJobReschedules?: Maybe<Array<Maybe<Reschedule>>>;
  getServiceCatalogue?: Maybe<Array<Maybe<Service>>>;
  getDefaultServices?: Maybe<PossibleEjiPriceResult>;
  generateServices?: Maybe<GenerateServicesResult>;
  calculatePossibleEJIPriceInfo?: Maybe<PossibleEjiPriceResult>;
  getPossibleService?: Maybe<PossibleEjiService>;
  getAllPossibleServices?: Maybe<Array<Maybe<PossibleEjiService>>>;
  getPartCatalogue?: Maybe<Array<Maybe<Part>>>;
  getPromoCode?: Maybe<PromoCode>;
  getPromoCodes?: Maybe<Array<Maybe<PromoCode>>>;
  getPromoCodeCoupon?: Maybe<PromoCode>;
  generateJobDiagnosticsSummary?: Maybe<Scalars["String"]>;
  getAllViocStores?: Maybe<Array<Maybe<ViocStore>>>;
  getLastVehicleOilChange?: Maybe<ExternalServiceHistoryType>;
  getPartOrders: PartOrdersConnection;
  getPartOrder: PartOrder;
  getPartOrderByNumber: PartOrder;
  getPartOrdersByJob: PartOrdersConnection;
  getMyPartOrders: Array<Maybe<PartOrder>>;
  getPartOrderItems: PartOrderItemsConnection;
  getPartOrderItem: PartOrderItemV2;
  getPartOrderItemsByPartOrder: Array<PartOrderItemV2>;
  getPackageDiscounts: Array<PackageDiscountType>;
  getActivePackageDiscounts: Array<PackageDiscountType>;
  getPackageDiscount?: Maybe<PackageDiscountType>;
  getGblLocations: Array<GblLocation>;
  getGblLocation?: Maybe<GblLocation>;
  getGblLocationByStoreId?: Maybe<GblLocation>;
  getGblLocationBySlug?: Maybe<GblLocation>;
  /** NUB-450: what applying the contact's current EIN would do to this invoice (read-only). */
  previewInvoiceTaxRecalculation: InvoiceTaxRecalculationPreview;
  /** NUB-450: unpaid invoices and open jobs whose price would change if the contact's EIN became this value (read-only). */
  previewContactTaxExemptionChange: Array<TaxExemptionAffectedRecord>;
};

export type QueryGetAppointmentSuggestionsArgs = {
  getAppointmentSuggestionsInput: GetAppointmentSuggestionsInput;
};

export type QueryGetUniqueAppointmentSuggestionsArgs = {
  getAppointmentSuggestionsInput: GetAppointmentSuggestionsInput;
};

export type QueryGetMarketArgs = {
  id: Scalars["ID"];
};

export type QueryGetMarketForAddressArgs = {
  address: Scalars["String"];
};

export type QueryCheckViocServiceabilityArgs = {
  address: Scalars["String"];
};

export type QueryGetMarketForZipcodeArgs = {
  zipcode: Scalars["String"];
};

export type QueryGetMakesArgs = {
  year: Scalars["String"];
};

export type QueryGetModelsArgs = {
  year: Scalars["String"];
  make: Scalars["String"];
};

export type QueryGetSubModelsArgs = {
  year: Scalars["String"];
  make: Scalars["String"];
  model: Scalars["String"];
};

export type QueryGetVehicleServiceExceptionArgs = {
  getVehicleServiceExceptionInput: GetVehicleServiceExceptionInput;
};

export type QueryGetServiceCatalogueItemArgs = {
  year: Scalars["String"];
  make: Scalars["String"];
  model: Scalars["String"];
  subModel: Scalars["String"];
  market: Scalars["String"];
};

export type QueryGetPartsStoresArgs = {
  filter?: Maybe<Scalars["JSON"]>;
};

export type QueryGetTechniciansHomePartsStoresArgs = {
  filter?: Maybe<Scalars["JSON"]>;
  referencePoint?: Maybe<GeocodeInput>;
};

export type QueryGetPartsStoreArgs = {
  id: Scalars["ID"];
};

export type QueryGetMyAppointmentsArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
  filter?: Maybe<Scalars["JSON"]>;
};

export type QueryGetAppointmentsArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
  filter?: Maybe<Scalars["JSON"]>;
  includeClosed?: Maybe<Scalars["Boolean"]>;
};

export type QueryGetAppointmentConflictsArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
  filter?: Maybe<Scalars["JSON"]>;
};

export type QueryGetAppointmentArgs = {
  id: Scalars["ID"];
};

export type QueryGetAppointmentCountByRangeArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
};

export type QueryGetContactsArgs = {
  cursor?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetContactsPaginatedArgs = {
  paginatedQueryInput: PaginatedQueryInput;
};

export type QueryGetContactCountByRangeArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
};

export type QueryGetDriveTimeArgs = {
  addresses: Array<Maybe<Scalars["String"]>>;
};

export type QueryGetEstimatesArgs = {
  filter?: Maybe<Scalars["JSON"]>;
  cursor?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetInvoicesPaginatedArgs = {
  paginatedQueryInput: PaginatedQueryInput;
};

export type QueryGetEstimatesPaginatedArgs = {
  paginatedQueryInput: PaginatedQueryInput;
};

export type QueryGetInvoicesArgs = {
  filter?: Maybe<Scalars["JSON"]>;
  cursor?: Maybe<Scalars["String"]>;
  sort?: Maybe<Scalars["JSON"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetVehicleMileageArgs = {
  vehicleId: Scalars["ID"];
  odometerHistoryInput?: Maybe<Array<Maybe<OdometerHistoryInput>>>;
};

export type QueryGetVehicleArgs = {
  id: Scalars["ID"];
  skipUpdate?: Maybe<Scalars["Boolean"]>;
};

export type QueryGetVehiclesArgs = {
  contactId: Scalars["ID"];
};

export type QueryGetInvoiceSalesByRangeArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
};

export type QueryGetJobsArgs = {
  filter?: Maybe<Scalars["JSON"]>;
  cursor?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetJobsPaginatedArgs = {
  paginatedQueryInput: PaginatedQueryInput;
};

export type QueryGetJobsPaginatedV2Args = {
  paginatedQueryInput: PaginatedQueryInput;
};

export type QueryGetJobCountByRangeArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
};

export type QueryGetJobsClosedInWindowArgs = {
  hoursBack?: Maybe<Scalars["Int"]>;
};

export type QueryGetRoLogArgs = {
  markets?: Maybe<Array<Scalars["String"]>>;
  dates?: Maybe<Array<Scalars["String"]>>;
};

export type QueryGetDispatchInDayArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
  markets?: Maybe<Array<Scalars["String"]>>;
};

export type QueryGetDispatchDayPrepArgs = {
  markets: Array<Scalars["String"]>;
  dates: Array<Scalars["String"]>;
};

export type QueryGetPaymentsArgs = {
  filter?: Maybe<Scalars["JSON"]>;
  cursor?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetPaymentsPaginatedArgs = {
  paginatedQueryInput: PaginatedQueryInput;
};

export type QueryGetTechniciansArgs = {
  filter?: Maybe<Scalars["JSON"]>;
};

export type QueryGetTechnicianArgs = {
  id: Scalars["ID"];
};

export type QueryGetEstimateArgs = {
  id: Scalars["ID"];
};

export type QueryGetPaymentArgs = {
  id: Scalars["ID"];
};

export type QueryGetContactArgs = {
  id: Scalars["ID"];
};

export type QueryGetContactExistsArgs = {
  id: Scalars["ID"];
};

export type QueryGetFilesArgs = {
  contactId: Scalars["ID"];
};

export type QueryGetJobArgs = {
  id: Scalars["ID"];
};

export type QueryGetJobPublicArgs = {
  id: Scalars["ID"];
};

export type QueryGetJobByTokenArgs = {
  token: Scalars["String"];
};

export type QueryGetDocumentToSignArgs = {
  id: Scalars["ID"];
};

export type QueryGetAvailabilityArgs = {
  getAvailabilityInput: GetAvailabilityInput;
};

export type QueryGetViocAvailabilityArgs = {
  getViocAvailabilityInput: GetViocAvailabilityInput;
};

export type QueryCustomerGetInvoiceArgs = {
  id: Scalars["ID"];
};

export type QueryGetInvoiceArgs = {
  id: Scalars["ID"];
};

export type QueryGetInvoicePublicArgs = {
  id: Scalars["ID"];
};

export type QueryGetProductArgs = {
  id: Scalars["ID"];
};

export type QueryGetActionsArgs = {
  entityName?: Maybe<Scalars["String"]>;
};

export type QuerySearchArgs = {
  query: Scalars["String"];
};

export type QuerySearchContactsArgs = {
  query: Scalars["String"];
  sort?: Maybe<Scalars["JSON"]>;
};

export type QuerySearchTechniciansArgs = {
  query: Scalars["String"];
  sort?: Maybe<Scalars["JSON"]>;
};

export type QuerySearchProductsArgs = {
  query: Scalars["String"];
  sort?: Maybe<Scalars["JSON"]>;
};

export type QueryGetProductSetArgs = {
  id: Scalars["ID"];
};

export type QueryGetReviewsArgs = {
  cursor?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryOneTimeIdValidArgs = {
  identifier: Scalars["String"];
};

export type QueryGetJobReschedulesArgs = {
  jobNumber: Scalars["String"];
};

export type QueryGetDefaultServicesArgs = {
  getDefaultServicesInput: GetDefaultServicesInput;
};

export type QueryGenerateServicesArgs = {
  generateServicesInput: GenerateServicesInput;
};

export type QueryCalculatePossibleEjiPriceInfoArgs = {
  calculatePossibleEJIPriceInfoInput: CalculatePossibleEjiPriceInfoInput;
};

export type QueryGetPossibleServiceArgs = {
  getPossibleServiceInput: GetPossibleServiceInput;
};

export type QueryGetAllPossibleServicesArgs = {
  getAllPossibleServicesInput: GetAllPossibleServicesInput;
};

export type QueryGetPromoCodeArgs = {
  code?: Maybe<Scalars["String"]>;
};

export type QueryGenerateJobDiagnosticsSummaryArgs = {
  generateJobDiagnosticsSummaryInput: GenerateJobDiagnosticsSummaryInput;
};

export type QueryGetAllViocStoresArgs = {
  filter?: Maybe<Scalars["JSON"]>;
};

export type QueryGetLastVehicleOilChangeArgs = {
  vehicleId: Scalars["ID"];
};

export type QueryGetPartOrdersArgs = {
  filter?: Maybe<Scalars["JSON"]>;
};

export type QueryGetPartOrderArgs = {
  id: Scalars["ID"];
};

export type QueryGetPartOrderByNumberArgs = {
  orderNumber: Scalars["Int"];
};

export type QueryGetPartOrdersByJobArgs = {
  jobId: Scalars["ID"];
};

export type QueryGetMyPartOrdersArgs = {
  startRange: Scalars["Date"];
  endRange: Scalars["Date"];
};

export type QueryGetPartOrderItemsArgs = {
  filter?: Maybe<Scalars["JSON"]>;
};

export type QueryGetPartOrderItemArgs = {
  id: Scalars["ID"];
};

export type QueryGetPartOrderItemsByPartOrderArgs = {
  partOrderId: Scalars["ID"];
};

export type QueryGetPackageDiscountArgs = {
  id: Scalars["ID"];
};

export type QueryGetGblLocationsArgs = {
  filter?: Maybe<Scalars["JSON"]>;
};

export type QueryGetGblLocationArgs = {
  id: Scalars["ID"];
};

export type QueryGetGblLocationByStoreIdArgs = {
  storeID: Scalars["String"];
};

export type QueryGetGblLocationBySlugArgs = {
  slug: Scalars["String"];
};

export type QueryPreviewInvoiceTaxRecalculationArgs = {
  invoiceId: Scalars["ID"];
};

export type QueryPreviewContactTaxExemptionChangeArgs = {
  contactId: Scalars["ID"];
  taxExemptEin?: Maybe<Scalars["String"]>;
};

export type Referral = {
  __typename?: "Referral";
  referralId?: Maybe<Scalars["String"]>;
  nubrakesReferralCode?: Maybe<Scalars["String"]>;
  shareUrl?: Maybe<Scalars["String"]>;
  referrer?: Maybe<Scalars["String"]>;
  metadata?: Maybe<Scalars["JSON"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
};

/**
 * Result of a live TaxJar re-trigger for a job (refreshJobTax). Non-throwing: reasons
 * carries the failure/issue codes (same codes the payment/invoice gate throws) when tax
 * still can't be confirmed; taxSource reflects the post-refresh provenance.
 */
export type RefreshJobTaxResult = {
  __typename?: "RefreshJobTaxResult";
  confirmed: Scalars["Boolean"];
  reasons: Array<Scalars["String"]>;
  taxSource?: Maybe<TaxSource>;
};

export type RepairServiceDetails = {
  __typename?: "RepairServiceDetails";
  service?: Maybe<Scalars["String"]>;
  inCount?: Maybe<Scalars["Boolean"]>;
  repairDate?: Maybe<Scalars["Date"]>;
  milesUntilRepair?: Maybe<Scalars["Int"]>;
};

export type Reschedule = {
  __typename?: "Reschedule";
  jobNumber: Scalars["String"];
  originalDates: RescheduleDates;
  newDates: RescheduleDates;
  rescheduleReason: Scalars["String"];
  rescheduleFiledBy: Scalars["String"];
  source?: Maybe<Scalars["String"]>;
};

export type RescheduleDates = {
  __typename?: "RescheduleDates";
  startDate: Scalars["Date"];
  endDate: Scalars["Date"];
};

export type RescheduleDatesInput = {
  startDate: Scalars["Date"];
  endDate: Scalars["Date"];
};

export type RescheduleInput = {
  jobNumber: Scalars["String"];
  originalDates: RescheduleDatesInput;
  newDates: RescheduleDatesInput;
  rescheduleReason: Scalars["String"];
};

export type RescheduleInputV2 = {
  jobNumber: Scalars["String"];
  originalDates: RescheduleDatesInput;
  newDates: RescheduleDatesInput;
  rescheduleReason: Scalars["String"];
  appointmentUpdates: AppointmentInput;
  appointmentId: Scalars["ID"];
};

export type RescheduleResultV2 = {
  __typename?: "RescheduleResultV2";
  jobNumber: Scalars["String"];
  originalDates: RescheduleDates;
  newDates: RescheduleDates;
  rescheduleReason: Scalars["String"];
  rescheduleFiledBy: Scalars["String"];
  appointment: Appointment;
};

export type RescheduleSummary = {
  __typename?: "RescheduleSummary";
  customerCount: Scalars["Int"];
  hqCount: Scalars["Int"];
  total: Scalars["Int"];
};

export type Restriction = {
  __typename?: "Restriction";
  firstTransaction?: Maybe<Scalars["Boolean"]>;
  minimumAmount?: Maybe<Scalars["Int"]>;
  customer?: Maybe<Scalars["String"]>;
  customerType?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  vehicleType?: Maybe<Scalars["String"]>;
  service?: Maybe<Scalars["String"]>;
  product?: Maybe<Scalars["String"]>;
  maxRedemptions?: Maybe<Scalars["Int"]>;
  minimumItemCount?: Maybe<Scalars["Int"]>;
};

export type RestrictionInput = {
  firstTransaction?: Maybe<Scalars["Boolean"]>;
  minimumAmount?: Maybe<Scalars["Int"]>;
  customer?: Maybe<Scalars["String"]>;
  customerType?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  vehicleType?: Maybe<Scalars["String"]>;
  service?: Maybe<Scalars["String"]>;
  product?: Maybe<Scalars["String"]>;
  maxRedemptions?: Maybe<Scalars["Int"]>;
  minimumItemCount?: Maybe<Scalars["Int"]>;
};

export type Review = {
  __typename?: "Review";
  rating: Scalars["String"];
  reviewerName: Scalars["String"];
  reviewType: Scalars["String"];
  branch?: Maybe<Scalars["String"]>;
  comment: Scalars["String"];
  dateCreated: Scalars["Date"];
};

export type ReviewConnection = {
  __typename?: "ReviewConnection";
  edges: Array<Review>;
  pageInfo: PageInfo;
};

export type ReviewMetaData = {
  __typename?: "ReviewMetaData";
  rating?: Maybe<Scalars["String"]>;
  reviewCount?: Maybe<Scalars["Int"]>;
};

export type RuleInput = {
  when: Array<ConditionInput>;
  discount: DiscountInput;
};

export type RuleType = {
  __typename?: "RuleType";
  when: Array<ConditionType>;
  discount: DiscountType;
};

export type SchedulingDay = {
  __typename?: "SchedulingDay";
  dayOfWeek?: Maybe<Scalars["String"]>;
  startTime?: Maybe<Scalars["String"]>;
  endTime?: Maybe<Scalars["String"]>;
};

export type SchedulingDayInput = {
  dayOfWeek?: Maybe<Scalars["String"]>;
  startTime?: Maybe<Scalars["String"]>;
  endTime?: Maybe<Scalars["String"]>;
};

export type Scores = {
  __typename?: "Scores";
  driveTime?: Maybe<Scalars["Float"]>;
  startTime?: Maybe<Scalars["Float"]>;
  numJobsOnDay?: Maybe<Scalars["Float"]>;
};

export type SearchResult = {
  __typename?: "SearchResult";
  contacts?: Maybe<Array<Maybe<Contact>>>;
  estimates?: Maybe<Array<Maybe<Estimate>>>;
};

export type SelfBookingData = {
  __typename?: "SelfBookingData";
  eligibility: Scalars["String"];
  selfSchedulingLink?: Maybe<Scalars["String"]>;
  events?: Maybe<Array<Maybe<Event>>>;
};

export type SelfScheduleContactUpdate = {
  contactId?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
};

export type SelfScheduleResponseData = {
  __typename?: "SelfScheduleResponseData";
  selfScheduleVehicleInfoUpdateIdentifier?: Maybe<Scalars["String"]>;
};

export type SelfScheduleVehicleInfo = {
  licensePlate?: Maybe<Scalars["String"]>;
  vin?: Maybe<Scalars["String"]>;
  licensePlateState?: Maybe<Scalars["String"]>;
};

export type SendEstimateForJobInput = {
  jobId: Scalars["ID"];
};

export type Service = {
  __typename?: "Service";
  id: Scalars["ID"];
  name: Scalars["String"];
  allowOnSiteAddOn?: Maybe<Scalars["Boolean"]>;
  technicianPay?: Maybe<Scalars["Currency"]>;
  products?: Maybe<Array<Maybe<ServiceProduct>>>;
};

export type ServiceCatalogueItem = {
  __typename?: "ServiceCatalogueItem";
  id: Scalars["ID"];
  year?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  subModel?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  frontPads?: Maybe<CataloguePads>;
  frontRotors?: Maybe<CatalogueRotors>;
  rearPads?: Maybe<CataloguePads>;
  rearRotors?: Maybe<CatalogueRotors>;
  shoes?: Maybe<CatalogueShoes>;
  drums?: Maybe<CatalogueDrums>;
  daysOfWeek?: Maybe<CatalogueDaysOfWeek>;
  leadTime?: Maybe<CatalogueLeadTime>;
};

export type ServiceFollowUp = {
  followUpNeeded?: Maybe<Scalars["Boolean"]>;
  outreachTimeline?: Maybe<Scalars["String"]>;
  outreachDate?: Maybe<Scalars["Date"]>;
  outreachNotes?: Maybe<Scalars["String"]>;
};

export type ServiceFollowUpInfo = {
  __typename?: "ServiceFollowUpInfo";
  followUpNeeded?: Maybe<Scalars["Boolean"]>;
  outreachTimeline?: Maybe<Scalars["String"]>;
  outreachDate?: Maybe<Scalars["Date"]>;
  outreachNotes?: Maybe<Scalars["String"]>;
  dateLeadCreated?: Maybe<Scalars["Date"]>;
  pipedriveDealId?: Maybe<Scalars["String"]>;
};

export type ServiceProduct = {
  __typename?: "ServiceProduct";
  id: Scalars["ID"];
  type: Scalars["String"];
  defaultUnits?: Maybe<Scalars["Float"]>;
  behavior: Scalars["String"];
  category: Scalars["String"];
  defaultCustomerPrice?: Maybe<Scalars["Currency"]>;
  defaultPartId?: Maybe<Scalars["Int"]>;
};

export type StartTimeRange = {
  __typename?: "StartTimeRange";
  startTime: Scalars["Date"];
  endTime: Scalars["Date"];
  numberOfPossibleTechnicians?: Maybe<Scalars["JSON"]>;
  technicians?: Maybe<Scalars["JSON"]>;
};

export type StartTimeRangeInput = {
  startTime: Scalars["Date"];
  endTime: Scalars["Date"];
};

export type StatusError = {
  __typename?: "StatusError";
  status?: Maybe<Array<Maybe<Scalars["String"]>>>;
  errors?: Maybe<Array<Maybe<Scalars["String"]>>>;
  data?: Maybe<SelfScheduleResponseData>;
};

export type TaxAudit = {
  __typename?: "TaxAudit";
  tax?: Maybe<TaxAuditTax>;
  invoiceJobComparison?: Maybe<InvoiceJobComparison>;
  passed?: Maybe<Scalars["Boolean"]>;
  auditedAt?: Maybe<Scalars["Date"]>;
};

export type TaxAuditTax = {
  __typename?: "TaxAuditTax";
  taxjarPayloadPresent?: Maybe<Scalars["Boolean"]>;
  taxjarPartsTaxRate?: Maybe<Scalars["Float"]>;
  taxjarLaborTaxRate?: Maybe<Scalars["Float"]>;
  taxjarPartsRateAudit?: Maybe<Scalars["Float"]>;
  taxjarLaborRateAudit?: Maybe<Scalars["Float"]>;
  partsTax?: Maybe<Scalars["Float"]>;
  laborTax?: Maybe<Scalars["Float"]>;
  totalTax?: Maybe<Scalars["Float"]>;
  partsRateMatchesPayload?: Maybe<Scalars["Boolean"]>;
  laborRateMatchesPayload?: Maybe<Scalars["Boolean"]>;
};

/** NUB-450: entityType is "Invoice" or "Job". */
export type TaxExemptionAffectedRecord = {
  __typename?: "TaxExemptionAffectedRecord";
  entityType: Scalars["String"];
  id: Scalars["ID"];
  number?: Maybe<Scalars["Int"]>;
  currentTaxable: Scalars["Boolean"];
  newTaxable: Scalars["Boolean"];
  currentAmountDue?: Maybe<Scalars["Currency"]>;
  newAmountDue?: Maybe<Scalars["Currency"]>;
  currentTotalTax?: Maybe<Scalars["Currency"]>;
  newTotalTax?: Maybe<Scalars["Currency"]>;
};

/** NUB-450 */
export type TaxExemptionRepriceResult = {
  __typename?: "TaxExemptionRepriceResult";
  entityType: Scalars["String"];
  id: Scalars["ID"];
  number?: Maybe<Scalars["Int"]>;
  success: Scalars["Boolean"];
  error?: Maybe<Scalars["String"]>;
  amountDue?: Maybe<Scalars["Currency"]>;
};

/**
 * Tax provenance for a priceInfo — tells the UI what the tax figure actually represents,
 * so users can tell a real TaxJar result from a fallback and spot TaxJar problems.
 *
 * CALCULATED: taxjarPayload is present (TaxJar ran); show the amount, even $0.00. UI label "Calculated Tax".
 * ESTIMATED: no payload, but a market fallback rate greater than 0 was applied (a real estimated tax). UI label "Estimated Tax".
 * TBC: no payload and the market rate is 0 (new/unconfigured market), so there is nothing to estimate. UI label "Tax: TBC".
 *
 * Only meaningful for taxable priceInfo; the frontend gates on `taxable` first.
 */
export enum TaxSource {
  Calculated = "CALCULATED",
  Estimated = "ESTIMATED",
  Tbc = "TBC",
}

export type Technician = {
  __typename?: "Technician";
  id: Scalars["ID"];
  auth0Id?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  isActive?: Maybe<Scalars["Boolean"]>;
  isVirtual?: Maybe<Scalars["Boolean"]>;
  isEllegibleToViocInspection?: Maybe<Scalars["Boolean"]>;
  isEligibleToViocInspection?: Maybe<Scalars["Boolean"]>;
  is1099?: Maybe<Scalars["Boolean"]>;
  role?: Maybe<TechnicianRole>;
  payMultiplier?: Maybe<Scalars["Float"]>;
  capacity?: Maybe<Scalars["Int"]>;
  capacityOverrides?: Maybe<Array<Maybe<TechnicianCapacityOverride>>>;
  speed?: Maybe<Scalars["Float"]>;
  specializedServices?: Maybe<Scalars["Boolean"]>;
  email?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  marketRef?: Maybe<Market>;
  partStoreId?: Maybe<Scalars["ID"]>;
  location?: Maybe<Location>;
  preferences?: Maybe<TechnicianPreferences>;
  timeZone?: Maybe<Scalars["String"]>;
  version?: Maybe<Scalars["String"]>;
  homePartsStore?: Maybe<PartsStore>;
  whenIWorkUserId?: Maybe<Scalars["String"]>;
  schedulingDays?: Maybe<Array<Maybe<SchedulingDay>>>;
  onWayMessage?: Maybe<Scalars["String"]>;
  serviceAreaAnchorAddress?: Maybe<Scalars["String"]>;
  homeAddress?: Maybe<Scalars["String"]>;
  numSlots?: Maybe<Scalars["Int"]>;
};

export type TechnicianCapacityOverride = {
  __typename?: "TechnicianCapacityOverride";
  startDate: Scalars["String"];
  endDate: Scalars["String"];
  capacity: Scalars["Int"];
  reason?: Maybe<Scalars["String"]>;
};

export type TechnicianCapacityOverrideInput = {
  startDate: Scalars["String"];
  endDate: Scalars["String"];
  capacity: Scalars["Int"];
  reason?: Maybe<Scalars["String"]>;
};

export type TechnicianCurrentAppVersion = {
  __typename?: "TechnicianCurrentAppVersion";
  version?: Maybe<Scalars["String"]>;
};

export type TechnicianDayCapacity = {
  __typename?: "TechnicianDayCapacity";
  date: Scalars["String"];
  capacity: Scalars["Int"];
  booked: Scalars["Int"];
  remaining: Scalars["Int"];
};

export type TechnicianPreferences = {
  __typename?: "TechnicianPreferences";
  receiveSMSNotifications?: Maybe<Scalars["Boolean"]>;
};

export type TechnicianPreferencesInput = {
  receiveSMSNotifications?: Maybe<Scalars["Boolean"]>;
};

export type TechnicianRole = {
  __typename?: "TechnicianRole";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  payMultiplier?: Maybe<Scalars["Float"]>;
};

export type TimeWindow = {
  __typename?: "TimeWindow";
  startTimeWindow?: Maybe<Scalars["Date"]>;
  endTimeWindow?: Maybe<Scalars["Date"]>;
};

export type TimeWindowInput = {
  startTimeWindow: Scalars["Date"];
  endTimeWindow: Scalars["Date"];
};

export type TireTreadDepth = {
  __typename?: "TireTreadDepth";
  depth?: Maybe<Scalars["String"]>;
  unavailable?: Maybe<Scalars["Boolean"]>;
};

export type TireTreadDepthInput = {
  depth?: Maybe<Scalars["String"]>;
  unavailable?: Maybe<Scalars["Boolean"]>;
};

export type TireTreadListItem = {
  __typename?: "TireTreadListItem";
  frontLeft?: Maybe<TireTreadDepth>;
  frontRight?: Maybe<TireTreadDepth>;
  rearLeft?: Maybe<TireTreadDepth>;
  rearRight?: Maybe<TireTreadDepth>;
};

export type TireTreadListItemInput = {
  frontLeft?: Maybe<TireTreadDepthInput>;
  frontRight?: Maybe<TireTreadDepthInput>;
  rearLeft?: Maybe<TireTreadDepthInput>;
  rearRight?: Maybe<TireTreadDepthInput>;
};

export type UpdateContactInput = {
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["String"]>;
  lead?: Maybe<UpdateLeadInput>;
  outreachMedium?: Maybe<Scalars["String"]>;
  billingType?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
  stripeCustomer?: Maybe<Scalars["JSON"]>;
  stripePaymentMethods?: Maybe<Array<Maybe<Scalars["JSON"]>>>;
  fleet?: Maybe<FleetInfoInput>;
  taxExemptEin?: Maybe<Scalars["String"]>;
};

export type UpdateDiagnosticsInput = {
  inquiryRequestId: Scalars["ID"];
  questionsAnswers?: Maybe<Array<Maybe<DiagnosticsQuestionAnswerInput>>>;
};

export type UpdateEstimateInput = {
  contact?: Maybe<Scalars["ID"]>;
  serviceLocation?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  status?: Maybe<Scalars["String"]>;
  issuedDate?: Maybe<Scalars["Date"]>;
  market?: Maybe<Scalars["String"]>;
  estimateNotes?: Maybe<Scalars["String"]>;
  serviceLocationNotes?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<Maybe<ItemInput>>>;
  services?: Maybe<Array<Maybe<EjiServiceInput>>>;
  discounts?: Maybe<Array<Maybe<EjiDiscountInput>>>;
  promoCodes?: Maybe<Array<Maybe<PromoCodeInput>>>;
  taxable?: Maybe<Scalars["Boolean"]>;
  createdBy?: Maybe<Scalars["String"]>;
  partsLeadTimeInDays?: Maybe<Scalars["Int"]>;
  callForPartsTicketNumber?: Maybe<Scalars["String"]>;
  partsNotes?: Maybe<Scalars["String"]>;
};

export type UpdateGblLocationInput = {
  name?: Maybe<Scalars["String"]>;
  slug?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  stateName?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["Int"]>;
  fullAddress?: Maybe<Scalars["String"]>;
  hours?: Maybe<GblLocationHoursInput>;
  services?: Maybe<Array<Scalars["String"]>>;
  mapUrl?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  isActive?: Maybe<Scalars["Boolean"]>;
};

export type UpdateInquiryWithConvertExperimentsDataInput = {
  inquiryRequestId?: Maybe<Scalars["String"]>;
  convertExperimentsData?: Maybe<Scalars["JSON"]>;
};

export type UpdateInvoiceInput = {
  contact?: Maybe<Scalars["ID"]>;
  serviceLocation?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  issuedDate?: Maybe<Scalars["Date"]>;
  technician?: Maybe<Scalars["ID"]>;
  dueDate?: Maybe<Scalars["Date"]>;
  market?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<Maybe<ItemInput>>>;
  services?: Maybe<Array<Maybe<EjiServiceInput>>>;
  discounts?: Maybe<Array<Maybe<EjiDiscountInput>>>;
  promoCodes?: Maybe<Array<Maybe<PromoCodeInput>>>;
  customerMessage?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  preJobCheckList?: Maybe<PreJobCheckListInput>;
  preJobCheckListV2?: Maybe<PreJobCheckListV2Input>;
  job?: Maybe<Scalars["ID"]>;
  taxable?: Maybe<Scalars["Boolean"]>;
  estimate?: Maybe<Scalars["ID"]>;
  createdBy?: Maybe<Scalars["String"]>;
  serviceFollowUp?: Maybe<ServiceFollowUp>;
  serviceCatalogueUsed?: Maybe<Scalars["String"]>;
};

export type UpdateJobConvertExperimentsByInquiryIdInput = {
  inquiryRequestId?: Maybe<Scalars["String"]>;
  experiment?: Maybe<ConvertExperiment>;
  variant?: Maybe<Scalars["String"]>;
};

export type UpdateJobInput = {
  contact?: Maybe<Scalars["ID"]>;
  feedback?: Maybe<JobFeedbackInput>;
  partsOrderingIssuesSurvey?: Maybe<PartsOrderingIssuesSurveyInput>;
  partsOrderingIssuesSurveys?: Maybe<Array<Maybe<PartsOrderingIssuesSurveyInput>>>;
  estimate?: Maybe<Scalars["ID"]>;
  serviceLocation?: Maybe<Scalars["String"]>;
  serviceLocationZip?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  serviceCallReason?: Maybe<Scalars["String"]>;
  serviceCallReasonExtraInfo?: Maybe<Scalars["String"]>;
  jobName?: Maybe<Scalars["String"]>;
  jobNotes?: Maybe<Scalars["String"]>;
  withdrawReason?: Maybe<Scalars["String"]>;
  withdrawExtraInfo?: Maybe<Scalars["String"]>;
  withdrawnAt?: Maybe<Scalars["Date"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  serviceLocationNotes?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  lockedTechnicianId?: Maybe<Scalars["ID"]>;
  specializedRequired?: Maybe<Scalars["Boolean"]>;
  inspectionRequired?: Maybe<Scalars["Boolean"]>;
  priority?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<Maybe<ItemInput>>>;
  approvalInfo?: Maybe<ApprovalInfoInput>;
  diagnosticJob?: Maybe<Scalars["ID"]>;
  services?: Maybe<Array<Maybe<EjiServiceInput>>>;
  discounts?: Maybe<Array<Maybe<EjiDiscountInput>>>;
  promoCodes?: Maybe<Array<Maybe<PromoCodeInput>>>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  vehicleId?: Maybe<Scalars["ID"]>;
  serviceLocationAddress?: Maybe<LocationAddressInput>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  partsInfo?: Maybe<PartsInfoInput>;
  preJobCheckList?: Maybe<PreJobCheckListInput>;
  preJobCheckListV2?: Maybe<PreJobCheckListV2Input>;
  jobCausedWarrantyCheck?: Maybe<Scalars["ID"]>;
  warrantyCheckReason?: Maybe<Scalars["String"]>;
  warrantyCheckReasonExtraInfo?: Maybe<Scalars["String"]>;
  warrantyCheckTechReason?: Maybe<Scalars["String"]>;
  warrantyCheckTechReasonExtraInfo?: Maybe<Scalars["String"]>;
  jobCausedDiagnostic?: Maybe<Scalars["ID"]>;
  jobViocInspection?: Maybe<Scalars["ID"]>;
  jobViocBrakeRepair?: Maybe<Scalars["ID"]>;
  appointment?: Maybe<Scalars["ID"]>;
  taxable?: Maybe<Scalars["Boolean"]>;
  contactCopy?: Maybe<Scalars["JSON"]>;
  createdBy?: Maybe<Scalars["String"]>;
  partsStore?: Maybe<Scalars["ID"]>;
  partsLeadTimeInDays?: Maybe<Scalars["Int"]>;
  zendeskTags?: Maybe<Array<Maybe<Scalars["String"]>>>;
  symptomDiagnosisCategory?: Maybe<Scalars["String"]>;
  viocStore?: Maybe<Scalars["ID"]>;
  locationType?: Maybe<Scalars["String"]>;
  earlyNotice?: Maybe<Scalars["Boolean"]>;
  VIOCSymptoms?: Maybe<Scalars["Boolean"]>;
  viocBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  viocMileageRange?: Maybe<Scalars["String"]>;
  viocLastBrakeRepair?: Maybe<Scalars["String"]>;
  viocRepairIntent?: Maybe<Scalars["String"]>;
  postJobChecklist?: Maybe<PostJobChecklistInput>;
  inspectionReportSentAt?: Maybe<Scalars["Date"]>;
  followUpDate?: Maybe<Scalars["Date"]>;
  deferredAt?: Maybe<Scalars["Date"]>;
  deferralSource?: Maybe<Scalars["String"]>;
};

export type UpdateJobPublicInput = {
  serviceLocation?: Maybe<Scalars["String"]>;
  serviceLocationZip?: Maybe<Scalars["String"]>;
  serviceLocationAddress?: Maybe<LocationAddressInput>;
  vehicleId?: Maybe<Scalars["ID"]>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  jobName?: Maybe<Scalars["String"]>;
  jobNotes?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  privateNotes?: Maybe<Scalars["String"]>;
  viocBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  viocMileageRange?: Maybe<Scalars["String"]>;
  viocLastBrakeRepair?: Maybe<Scalars["String"]>;
  viocRepairIntent?: Maybe<Scalars["String"]>;
  followUpDate?: Maybe<Scalars["Date"]>;
  deferredAt?: Maybe<Scalars["Date"]>;
  deferralSource?: Maybe<Scalars["String"]>;
};

export type UpdateLeadInput = {
  address?: Maybe<Scalars["String"]>;
  market?: Maybe<Scalars["String"]>;
  source?: Maybe<Scalars["String"]>;
  hearAboutUs?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  vehicleInfo?: Maybe<VehicleInfoInput>;
  vehicleSymptoms?: Maybe<Array<Maybe<VehicleSymptomInput>>>;
  requestedServices?: Maybe<Array<Maybe<Scalars["String"]>>>;
  serviceUrgency?: Maybe<Scalars["String"]>;
};

export type UpdateLocationInput = {
  coordinates: Array<Scalars["Float"]>;
};

export type UpdateMarketInput = {
  name?: Maybe<Scalars["String"]>;
  timeZone?: Maybe<Scalars["String"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  addressStreet?: Maybe<Scalars["String"]>;
  addressCity?: Maybe<Scalars["String"]>;
  addressState?: Maybe<Scalars["String"]>;
  addressZipCode?: Maybe<Scalars["String"]>;
  addressCountry?: Maybe<Scalars["String"]>;
  businessID?: Maybe<Scalars["String"]>;
  activeServiceArea?: Maybe<Scalars["JSON"]>;
  activeServiceAreaGeoJson?: Maybe<Scalars["JSON"]>;
  marketArea?: Maybe<Scalars["JSON"]>;
  marketAreaGeoJson?: Maybe<Scalars["JSON"]>;
  marketStatus?: Maybe<MarketStatusEnum>;
  visitBalanceCoefficient?: Maybe<Scalars["Float"]>;
  traffic?: Maybe<Scalars["String"]>;
  maxVisitLateness?: Maybe<Scalars["Int"]>;
  maxVehicleOvertime?: Maybe<Scalars["Int"]>;
  padsPricingVariance?: Maybe<MarketPricingVarianceInput>;
  rotorsPricingVariance?: Maybe<MarketPricingVarianceInput>;
  shoesPricingVariance?: Maybe<MarketPricingVarianceInput>;
  drumsPricingVariance?: Maybe<MarketPricingVarianceInput>;
  variance?: Maybe<MarketVarianceInput>;
  salesTaxType?: Maybe<Scalars["String"]>;
  partsTaxRate?: Maybe<Scalars["Float"]>;
  laborTaxRate?: Maybe<Scalars["Float"]>;
  laborRate?: Maybe<Scalars["Currency"]>;
  vendorUnitCostMultipliers?: Maybe<Array<Maybe<VendorUnitCostMultiplierInput>>>;
};

export type UpdateMyAppointmentEmailInput = {
  token: Scalars["String"];
  email: Scalars["String"];
};

export type UpdateMyAppointmentEmailResponse = {
  __typename?: "UpdateMyAppointmentEmailResponse";
  jobId?: Maybe<Scalars["ID"]>;
  email?: Maybe<Scalars["String"]>;
};

export type UpdatePartOrderInput = {
  job?: Maybe<Scalars["ID"]>;
  orderNumber?: Maybe<Scalars["String"]>;
  store?: Maybe<Scalars["ID"]>;
  partsLocation?: Maybe<Scalars["String"]>;
  notes?: Maybe<Scalars["String"]>;
  orderTotalCost?: Maybe<Scalars["Float"]>;
  orderMethod?: Maybe<Scalars["String"]>;
  partOrderingIssue?: Maybe<Scalars["String"]>;
  partOrderingIssueNotes?: Maybe<Scalars["String"]>;
  cancelationDetails?: Maybe<CancelationDetailsInput>;
  items?: Maybe<Array<Maybe<UpdatePartOrderItemInput>>>;
};

export type UpdatePartOrderItemInput = {
  id?: Maybe<Scalars["ID"]>;
  units?: Maybe<Scalars["Float"]>;
  vendorUnitCost?: Maybe<Scalars["Float"]>;
  partNumber?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  status?: Maybe<PartOrderItemStatus>;
  ejiItem?: Maybe<Scalars["ID"]>;
};

export type UpdateProductInput = {
  name?: Maybe<Scalars["String"]>;
  laborCost?: Maybe<Scalars["Currency"]>;
  partsCost?: Maybe<Scalars["Currency"]>;
  amount?: Maybe<Scalars["Currency"]>;
  description?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type UpdateProductSetInput = {
  name?: Maybe<Scalars["String"]>;
  products?: Maybe<Array<Maybe<Scalars["ID"]>>>;
  description?: Maybe<Scalars["String"]>;
};

export type UpdatePromoCodeInput = {
  id: Scalars["ID"];
  code: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
  createdBy?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  coupon?: Maybe<CouponInput>;
  expiry?: Maybe<Scalars["Date"]>;
  restrictions?: Maybe<Array<Maybe<RestrictionInput>>>;
  totalRedemptions?: Maybe<Scalars["Int"]>;
  combinable?: Maybe<Scalars["Boolean"]>;
};

export type UpdateSelfScheduledJobVehicleInformationInput = {
  jobId: Scalars["ID"];
  selfScheduleVehicleInfoUpdateIdentifier: Scalars["String"];
  vehicleInfo: SelfScheduleVehicleInfo;
};

export type UpdateSelfScheduledJobVehicleInformationResponse = {
  __typename?: "UpdateSelfScheduledJobVehicleInformationResponse";
  jobId?: Maybe<Scalars["ID"]>;
};

export type UpdateTechnicianInput = {
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  payMultiplier?: Maybe<Scalars["Float"]>;
  capacity?: Maybe<Scalars["Int"]>;
  capacityOverrides?: Maybe<Array<Maybe<TechnicianCapacityOverrideInput>>>;
  speed?: Maybe<Scalars["Float"]>;
  specializedServices?: Maybe<Scalars["Boolean"]>;
  phoneNumber?: Maybe<Scalars["String"]>;
  role?: Maybe<Scalars["ID"]>;
  roleCopy?: Maybe<Scalars["JSON"]>;
  market?: Maybe<Scalars["String"]>;
  isActive?: Maybe<Scalars["Boolean"]>;
  isVirtual?: Maybe<Scalars["Boolean"]>;
  isEllegibleToViocInspection?: Maybe<Scalars["Boolean"]>;
  is1099?: Maybe<Scalars["Boolean"]>;
  location?: Maybe<UpdateLocationInput>;
  preferences?: Maybe<TechnicianPreferencesInput>;
  timeZone?: Maybe<Scalars["String"]>;
  version?: Maybe<Scalars["String"]>;
  homePartsStore?: Maybe<Scalars["ID"]>;
  whenIWorkUserId?: Maybe<Scalars["String"]>;
  schedulingDays?: Maybe<Array<Maybe<SchedulingDayInput>>>;
  onWayMessage?: Maybe<Scalars["String"]>;
  serviceAreaAnchorAddress?: Maybe<Scalars["String"]>;
  homeAddress?: Maybe<Scalars["String"]>;
};

export type User = {
  __typename?: "User";
  email?: Maybe<Scalars["String"]>;
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  password?: Maybe<Scalars["String"]>;
};

export enum UserRole {
  Manager = "manager",
  AgentOpsTechs = "agent_ops_techs",
  AgentOpsOnly = "agent_ops_only",
  Technician = "technician",
}

export type VehicleInfo = {
  __typename?: "VehicleInfo";
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  licensePlateState?: Maybe<Scalars["String"]>;
  vin?: Maybe<Scalars["String"]>;
  odometer?: Maybe<Scalars["String"]>;
  discardThickness?: Maybe<Scalars["Float"]>;
  frontRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  rearRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  frontPadLife?: Maybe<Scalars["String"]>;
  rearPadLife?: Maybe<Scalars["String"]>;
  extraInfo?: Maybe<Scalars["String"]>;
  wheelTorque?: Maybe<Scalars["Float"]>;
  frontBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  rearBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  customerExpectation?: Maybe<Scalars["String"]>;
  additionalNotes?: Maybe<Scalars["String"]>;
  symptoms?: Maybe<Scalars["String"]>;
  CCA?: Maybe<Scalars["Int"]>;
};

export type VehicleInfoInput = {
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  licensePlateState?: Maybe<Scalars["String"]>;
  vin?: Maybe<Scalars["String"]>;
  odometer?: Maybe<Scalars["String"]>;
  discardThickness?: Maybe<Scalars["Float"]>;
  frontRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  rearRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  frontPadLife?: Maybe<Scalars["String"]>;
  rearPadLife?: Maybe<Scalars["String"]>;
  extraInfo?: Maybe<Scalars["String"]>;
  wheelTorque?: Maybe<Scalars["Float"]>;
  frontBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  rearBrakeSymptoms?: Maybe<Array<Maybe<Scalars["String"]>>>;
  customerExpectation?: Maybe<Scalars["String"]>;
  additionalNotes?: Maybe<Scalars["String"]>;
  symptoms?: Maybe<Scalars["String"]>;
  CCA?: Maybe<Scalars["Int"]>;
};

export type VehicleInput = {
  id?: Maybe<Scalars["ID"]>;
  contactId: Scalars["ID"];
  make: Scalars["String"];
  model: Scalars["String"];
  subModel?: Maybe<Scalars["String"]>;
  CCA?: Maybe<Scalars["Int"]>;
  year: Scalars["String"];
  vin?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  licensePlateState?: Maybe<Scalars["String"]>;
  wheelTorque?: Maybe<Scalars["String"]>;
  frontRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  rearRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  notes?: Maybe<Scalars["String"]>;
  odometer?: Maybe<Scalars["String"]>;
  inactive?: Maybe<Scalars["Boolean"]>;
  hasDrumBrakes?: Maybe<Scalars["Boolean"]>;
  parkingBrake?: Maybe<Scalars["String"]>;
  oilCapacityQuarts?: Maybe<Scalars["Float"]>;
  odometerHistory?: Maybe<Array<Maybe<OdometerHistoryInput>>>;
};

export type VehicleMileageDetails = {
  __typename?: "VehicleMileageDetails";
  milesPerYear?: Maybe<Scalars["Int"]>;
  mileageOnLastService?: Maybe<Scalars["Int"]>;
  mileageSinceLastService?: Maybe<Scalars["Int"]>;
  currentMilage?: Maybe<Scalars["Int"]>;
  snapshotData?: Maybe<Array<Maybe<VehicleSnapshotItem>>>;
  lastServiceDate?: Maybe<Scalars["Date"]>;
  repairServicesDetails?: Maybe<Array<Maybe<RepairServiceDetails>>>;
  lastJob?: Maybe<Job>;
};

export type VehicleServiceException = {
  __typename?: "VehicleServiceException";
  id?: Maybe<Scalars["String"]>;
  vehicleMake?: Maybe<Scalars["String"]>;
  vehicleModel?: Maybe<Scalars["String"]>;
  vehicleSubmodel?: Maybe<Scalars["String"]>;
  yearRangeStart?: Maybe<Scalars["Int"]>;
  yearRangeEnd?: Maybe<Scalars["Int"]>;
  VehicleServiceExceptionRuleId?: Maybe<Scalars["String"]>;
  attributes?: Maybe<Scalars["JSON"]>;
};

export type VehicleSnapshotItem = {
  __typename?: "VehicleSnapshotItem";
  service?: Maybe<Scalars["String"]>;
  thickness?: Maybe<Scalars["String"]>;
  condition?: Maybe<Scalars["JSON"]>;
  status?: Maybe<Scalars["String"]>;
  replaced?: Maybe<Scalars["String"]>;
  configIndex?: Maybe<Scalars["Int"]>;
  servicesIds?: Maybe<Array<Maybe<Scalars["String"]>>>;
};

export type VehicleSymptom = {
  __typename?: "VehicleSymptom";
  axle?: Maybe<Scalars["String"]>;
  symptom?: Maybe<Scalars["String"]>;
};

export type VehicleSymptomInput = {
  axle?: Maybe<Scalars["String"]>;
  symptom?: Maybe<Scalars["String"]>;
};

export type VehicleTechnicalInfo = {
  __typename?: "VehicleTechnicalInfo";
  wheelTorque?: Maybe<Scalars["String"]>;
  frontRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  rearRotorsDiscardThicknessInches?: Maybe<Scalars["Float"]>;
  hasDrumBrakes?: Maybe<Scalars["Boolean"]>;
  parkingBrake?: Maybe<Scalars["String"]>;
  oilCapacityQuarts?: Maybe<Scalars["Float"]>;
};

export type VehicleType = {
  __typename?: "VehicleType";
  id?: Maybe<Scalars["String"]>;
  contactId?: Maybe<Scalars["ID"]>;
  CCA?: Maybe<Scalars["Int"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  subModel?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["String"]>;
  vin?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  licensePlate?: Maybe<Scalars["String"]>;
  licensePlateState?: Maybe<Scalars["String"]>;
  odometer?: Maybe<Scalars["String"]>;
  odometerHistory?: Maybe<Array<Maybe<OdometerHistoryType>>>;
  vehicleTechnicalInfo?: Maybe<VehicleTechnicalInfo>;
  externalServiceHistory?: Maybe<Array<Maybe<ExternalServiceHistoryType>>>;
  notes?: Maybe<Scalars["String"]>;
  inactive?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["Date"]>;
  updatedAt?: Maybe<Scalars["Date"]>;
  lastNotice?: Maybe<Scalars["Date"]>;
  unserviceable?: Maybe<Scalars["Boolean"]>;
};

export type VehicleWithServices = {
  __typename?: "VehicleWithServices";
  vehicle: VehicleType;
  services: Array<Maybe<Scalars["String"]>>;
};

export type VendorUnitCostMultiplier = {
  __typename?: "VendorUnitCostMultiplier";
  startRangePrice?: Maybe<Scalars["Currency"]>;
  endRangePrice?: Maybe<Scalars["Currency"]>;
  multiplier?: Maybe<Scalars["Float"]>;
};

export type VendorUnitCostMultiplierInput = {
  startRangePrice?: Maybe<Scalars["Currency"]>;
  endRangePrice?: Maybe<Scalars["Currency"]>;
  multiplier?: Maybe<Scalars["Float"]>;
};

export type ViocLead = {
  __typename?: "ViocLead";
  id: Scalars["ID"];
  phoneNumber?: Maybe<Scalars["String"]>;
  windowUrl?: Maybe<Scalars["String"]>;
  queryParams?: Maybe<Scalars["JSON"]>;
  extraFields?: Maybe<Scalars["JSON"]>;
};

export type ViocSelfScheduleResponseData = {
  __typename?: "ViocSelfScheduleResponseData";
  selfScheduleVehicleInfoUpdateIdentifier?: Maybe<Scalars["String"]>;
};

export type ViocSelfScheduleStatusError = {
  __typename?: "ViocSelfScheduleStatusError";
  status?: Maybe<Array<Maybe<Scalars["String"]>>>;
  errors?: Maybe<Array<Maybe<Scalars["String"]>>>;
  data?: Maybe<ViocSelfScheduleResponseData>;
};

export type ViocStore = {
  __typename?: "ViocStore";
  id: Scalars["ID"];
  storeNumber?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  zip?: Maybe<Scalars["String"]>;
  isActive?: Maybe<Scalars["Boolean"]>;
};
